// AUTO-GENERATED for Phase C logged-out curriculum grid.
// EN fields: authoritative box DB (pe_chapters / pe_episodes). Vocab defs/examples: pe_vocabulary_terms (real bilingual).
// ES chapter title/summary/fl_pillar: on-disk native Spanish (reverse_engineered_spines + ES scripts) [REVIEW].
// ES vocab headword (word_es): pe_concept_lexemes.term WHERE language='es' (primary = lowest id per concept).
//   word/word_es are LOOKUP values (slug + raw lexeme); the component formats them for display
//   (underscores -> spaces; slug-only fallbacks title-cased). Where word_es is null, ES silently shows the EN headword.
// Do not hand-edit; regenerate.

export type Lang = "en" | "es";
export interface PeVocab { word: string; word_es: string | null; def_en: string; def_es: string | null; ex_en: string | null; ex_es: string | null; }
export interface PeChapter {
  season: number; chapter: number; slug: string;
  title: string; title_es: string | null;
  summary: string; summary_es: string | null;
  fl_pillar: string; fl_pillar_es: string | null;
  thumbnails: Record<string, { en: string; es: string }>;
  vocab: PeVocab[];
}
export const peCurriculum: PeChapter[] = [
  {
    "season": 1,
    "chapter": 1,
    "slug": "s1-ch01",
    "title": "THE SECRET GARDEN",
    "summary": "Layla discovers a hidden path behind an old fence on her walk home from school, leading to a secret overgrown garden. She gathers her friends to explore it together, and they find natural treasures — a striped stone, a Y-shaped stick, colorful leaves, and acorns. Mister Mason arrives and reveals he has been planting seeds there for years. He teaches them that some of the most valuable things in life cost nothing at all.",
    "fl_pillar": "Finding versus buying, free natural resources, understanding value without money",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch1/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch1/t1/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch1/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch1/t4/es.jpeg"
      },
      "t2": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch1/t2/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch1/t2/en.jpeg"
      },
      "t3": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch1/t3/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch1/t3/en.jpeg"
      }
    },
    "vocab": [
      {
        "word": "value",
        "def_en": "how important or useful something is",
        "def_es": "lo que algo vale, no solo en dinero sino en cuánto ayuda a las personas",
        "ex_en": "Benny said the free things in the garden still had real value for the friends.",
        "ex_es": "Benny dijo que las cosas gratis del jardín tenían un valor real para los amigos.",
        "word_es": "valor"
      },
      {
        "word": "free",
        "def_en": "costs no money, available without payment",
        "def_es": "que no cuesta dinero y se puede tener sin pagar",
        "ex_en": "Layla's striped stone was free, so nobody had to pay for it.",
        "ex_es": "La piedra rayada de Layla era gratis, así que nadie tuvo que pagar.",
        "word_es": "gratis"
      },
      {
        "word": "resource",
        "def_en": "something useful that nature or people provide",
        "def_es": "Todo lo que se necesita para hacer algo: materiales, dinero, tiempo, esfuerzo",
        "ex_en": "The fallen branch was a free resource that Riley could use for drawing.",
        "ex_es": "La rama caída era un recurso gratis que Riley podía usar para dibujar.",
        "word_es": "recurso"
      },
      {
        "word": "care",
        "def_en": "to treat something with care",
        "def_es": "tratar algo con cuidado",
        "ex_en": "Layla passed the smooth stone to Riley with care.",
        "ex_es": "Layla le pasó la piedra lisa a Riley con cuidado.",
        "word_es": "cuidado"
      },
      {
        "word": "purchase",
        "def_en": "to get something by paying money",
        "def_es": "conseguir algo pagando dinero",
        "ex_en": "Layla and her friends made no purchase in the garden.",
        "ex_es": "Layla y sus amigos no hicieron ninguna compra en el jardín.",
        "word_es": "compra"
      }
    ],
    "title_es": "EL JARDÍN SECRETO",
    "summary_es": "Layla descubre un camino oculto detrás de una cerca vieja mientras camina a casa desde la escuela, que conduce a un jardín secreto cubierto de vegetación. Reúne a sus amigos para explorarlo juntos, y encuentran tesoros naturales: una piedra con rayas, un palo en forma de Y, hojas coloridas y bellotas. Mister Mason llega y revela que ha estado plantando semillas allí durante años. Les enseña que algunas de las cosas más valiosas de la vida no cuestan nada.",
    "fl_pillar_es": "Encontrar versus comprar, recursos naturales gratuitos, entender el valor sin dinero"
  },
  {
    "season": 1,
    "chapter": 2,
    "slug": "s1-ch02",
    "title": "THE SEED LIBRARY",
    "summary": "Riley encounters Frances, a kind elderly neighbor tending a beautiful garden. Frances introduces the four friends to her seed library — decades of saved seeds stored in jars inside a garden shed. The friends each plant a seed in a clay pot, but Riley grows impatient wanting instant results. Frances teaches her that seeds, like investments, need time and care to grow. The friends leave with their planted pots, understanding that small beginnings can lead to large returns if you are patient.",
    "fl_pillar": "Small investments grow over time, delayed rewards, future value, compounding returns from nature",
    "thumbnails": {
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch2/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch2/t4/es.jpeg"
      },
      "t1": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch2/t1/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch2/t1/en.jpeg"
      },
      "t2": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch2/t2/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch2/t2/en.jpeg"
      },
      "t3": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch2/t3/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch2/t3/en.jpeg"
      }
    },
    "vocab": [
      {
        "word": "scarcity",
        "def_en": "when there is too little of something; abundance is when there is more than enough",
        "def_es": "Escasez es cuando hay muy poco de algo; abundancia es cuando hay mucho más de lo necesario",
        "ex_en": "Frances's jars of seeds show abundance, because one plant makes hundreds of seeds.",
        "ex_es": "Los frascos de semillas de Frances muestran abundancia, porque una planta da cientos de semillas.",
        "word_es": "escasez"
      },
      {
        "word": "investment",
        "def_en": "something you start small that grows bigger over time",
        "def_es": "Poner algo de valor (tiempo, esfuerzo, dinero) con la esperanza de que crezca y produzca más",
        "ex_en": "Frances turned a few original packets into a lasting investment by saving seeds for more than fifty years.",
        "ex_es": "Frances convirtió unos pocos paquetes originales en una inversión duradera al guardar semillas por más de cincuenta años.",
        "word_es": "inversión"
      },
      {
        "word": "business_cycle",
        "def_en": "a process that repeats itself over and over",
        "def_es": "Los pasos completos de un negocio o el patrón que se repite — incluyendo las temporadas altas y bajas",
        "ex_en": "In the seed library, people borrow seeds and return new ones in a cycle that never ends.",
        "ex_es": "En la biblioteca de semillas, la gente pide semillas prestadas y devuelve nuevas en un ciclo que nunca termina.",
        "word_es": "ciclo de negocio"
      },
      {
        "word": "patience",
        "def_en": "the ability to wait calmly",
        "def_es": "la capacidad de esperar con calma",
        "ex_en": "Riley sighed because patience was hard for her when she wanted green shoots now.",
        "ex_es": "Riley suspiró porque la paciencia le costaba mucho cuando quería ver brotes verdes ya.",
        "word_es": "paciencia"
      },
      {
        "word": "seed",
        "def_en": "tiny starts of plants that grow with time and care",
        "def_es": "pequeños comienzos de plantas que crecen con tiempo y cuidado",
        "ex_en": "Benny picked huge sunflower seeds and held one up between two fingers.",
        "ex_es": "Benny escogió semillas de girasol enormes y levantó una entre dos dedos.",
        "word_es": "semilla"
      },
      {
        "word": "growth",
        "def_en": "to get bigger over time",
        "def_es": "hacerse más grande con el tiempo",
        "ex_en": "Growth takes time, Frances told Riley.",
        "ex_es": "Frances le dijo a Riley que el crecimiento necesita tiempo.",
        "word_es": "crecimiento"
      }
    ],
    "title_es": "LA BIBLIOTECA DE SEMILLAS",
    "summary_es": "Riley conoce a Frances, una amable vecina mayor que cuida un hermoso jardín. Frances presenta a los cuatro amigos su biblioteca de semillas — décadas de semillas guardadas en frascos dentro de un cobertizo. Los amigos plantan una semilla cada uno en una maceta de barro, pero Riley se impacienta queriendo resultados inmediatos. Frances le enseña que las semillas, como las inversiones, necesitan tiempo y cuidado para crecer. Los amigos se van con sus macetas plantadas, entendiendo que los comienzos pequeños pueden llevar a grandes resultados si se tiene paciencia.",
    "fl_pillar_es": "Las pequeñas inversiones crecen con el tiempo, recompensas diferidas, valor futuro, rendimientos compuestos de la naturaleza"
  },
  {
    "season": 1,
    "chapter": 3,
    "slug": "s1-ch03",
    "title": "THE TRADING POST",
    "summary": "Ellis realizes he has outgrown many toys that are still in good condition and proposes a neighborhood trading post where kids can exchange items they no longer need. The friends set up in Layla's backyard, but Riley raises the problem of how to keep trades fair. Ellis discovers old wooden tokens in a shed and creates a value system based on size, condition, and usefulness. The trading post opens, neighborhood kids participate, and Mister Mason stops by to share that bartering has a long history. The friends learn that creativity and fairness can replace money.",
    "fl_pillar": "Bartering, exchange of value, needs versus wants, reusing resources",
    "thumbnails": {
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch3/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch3/t4/es.jpeg"
      },
      "t1": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch3/t1/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch3/t1/en.jpeg"
      },
      "t2": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch3/t2/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch3/t2/en.jpeg"
      },
      "t3": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch3/t3/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch3/t3/en.jpeg"
      }
    },
    "vocab": [
      {
        "word": "value",
        "def_en": "how much something is worth",
        "def_es": "lo que algo vale, no solo en dinero sino en cuánto ayuda a las personas",
        "ex_en": "Ellis said smaller or older items get fewer tokens because they have less value.",
        "ex_es": "Ellis dijo que las cosas más chicas o más viejas reciben menos fichas porque tienen menos valor.",
        "word_es": "valor"
      },
      {
        "word": "resource",
        "def_en": "something useful that can be shared or traded",
        "def_es": "Todo lo que se necesita para hacer algo: materiales, dinero, tiempo, esfuerzo",
        "ex_en": "Mister Mason said the friends were learning lessons about resource management and community cooperation.",
        "ex_es": "El señor Mason dijo que los amigos aprendían lecciones sobre el manejo de recursos y la cooperación en la comunidad.",
        "word_es": "recurso"
      },
      {
        "word": "trade_barter",
        "def_en": "to swap one thing for another",
        "def_es": "Cambiar una cosa por otra (trueque, sin dinero) o entregar un producto a cambio de dinero (transacción)",
        "ex_en": "The friends swapped old toys in the yard.",
        "ex_es": "Los amigos intercambiaban juguetes viejos en el patio.",
        "word_es": "trueque"
      }
    ],
    "title_es": "EL PUESTO DE INTERCAMBIO",
    "summary_es": "Ellis se da cuenta de que tiene muchos juguetes en buen estado que ya no usa y propone un puesto de intercambio en el vecindario donde los niños puedan cambiar cosas que ya no necesitan. Los amigos lo organizan en el patio trasero de Layla, pero Riley plantea el problema de cómo mantener los intercambios justos. Ellis descubre fichas de madera antiguas en un cobertizo y crea un sistema de valor basado en tamaño, condición y utilidad. El puesto de intercambio abre, los niños del vecindario participan, y Mister Mason pasa a compartir que el trueque tiene una larga historia. Los amigos aprenden que la creatividad y la justicia pueden reemplazar al dinero.",
    "fl_pillar_es": "Trueque, intercambio de valor, necesidades versus deseos, reutilización de recursos"
  },
  {
    "season": 1,
    "chapter": 4,
    "slug": "s1-ch04",
    "title": "THE CREEK EXPLORERS",
    "summary": "Benny discovers a yellowed, hand-drawn map hidden in his attic and rallies his friends for an expedition. Following the map through the woods, they discover a creek with a small waterfall, collect natural treasures along the banks, and work together to cross the water on stepping stones. On the far side, they find Mister Mason sketching in a notebook. He reveals that he drew the map decades ago as a boy, and he gives the friends a new journal to record their own adventures.",
    "fl_pillar": "None — pure adventure and friendship",
    "thumbnails": {
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch4/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch4/t4/es.jpeg"
      },
      "t1": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch4/t1/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch4/t1/en.jpeg"
      },
      "t2": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch4/t2/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch4/t2/en.jpeg"
      },
      "t3": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch4/t3/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch4/t3/en.jpeg"
      }
    },
    "vocab": [
      {
        "word": "explore",
        "def_en": "to find something new",
        "def_es": "encontrar algo nuevo",
        "ex_en": "Layla and her friends wanted to explore the other side of the creek.",
        "ex_es": "Layla y sus amigos querían explorar el otro lado del arroyo.",
        "word_es": "explorar"
      },
      {
        "word": "navigate",
        "def_en": "a drawing that shows where to go",
        "def_es": "un dibujo que muestra por dónde ir",
        "ex_en": "They used the map to navigate to the creek.",
        "ex_es": "Usaron el mapa para navegar hasta el arroyo.",
        "word_es": "navegar"
      },
      {
        "word": "stable",
        "def_en": "steady and safe",
        "def_es": "firme y seguro",
        "ex_en": "Layla said the first rock was stable.",
        "ex_es": "Layla dijo que la primera roca era estable.",
        "word_es": "estable"
      },
      {
        "word": "landscape",
        "def_en": "the natural features of land",
        "def_es": "las partes naturales de la tierra",
        "ex_en": "The creek, the tall trees and the swaying grass made a beautiful landscape.",
        "ex_es": "El arroyo, los árboles altos y la hierba que se mecía formaban un paisaje hermoso.",
        "word_es": "paisaje"
      },
      {
        "word": "waterfall",
        "def_en": "water flowing down in stages",
        "def_es": "agua que baja por escalones",
        "ex_en": "Benny found a small waterfall where water fell over mossy rocks.",
        "ex_es": "Benny encontró una cascada pequeña donde el agua caía sobre rocas con musgo.",
        "word_es": "cascada"
      }
    ],
    "title_es": "LOS EXPLORADORES DEL ARROYO",
    "summary_es": "Benny descubre un mapa amarillento dibujado a mano, escondido en su ático, y reúne a sus amigos para una expedición. Siguiendo el mapa a través del bosque, descubren un arroyo con una pequeña cascada, recogen tesoros naturales a lo largo de las orillas y trabajan juntos para cruzar el agua sobre piedras. Al otro lado, encuentran a Mister Mason dibujando en un cuaderno. Él revela que dibujó el mapa hace décadas cuando era niño, y les da a los amigos un diario nuevo para que registren sus propias aventuras.",
    "fl_pillar_es": "Ninguno — pura aventura y amistad"
  },
  {
    "season": 1,
    "chapter": 5,
    "slug": "s1-ch05",
    "title": "RILEY'S ART STAND",
    "summary": "Riley is a talented artist who hides her work because she believes it is not good enough. When Ellis accidentally discovers her hidden drawings, he and their friends convince her to share them at a free art stand on the sidewalk. As neighbors respond with delight and ask Riley to teach them, she discovers that her talent has real value — not in money, but in the joy and connection it brings to others.",
    "fl_pillar": "Skills have value, giving vs selling",
    "thumbnails": {
      "t1": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch5/t1/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch5/t1/en.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch5/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch5/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch5/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch5/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch5/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch5/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "value",
        "def_en": "the worth something has, not just in money but in how it helps people",
        "def_es": "lo que algo vale, no solo en dinero sino en cuánto ayuda a las personas",
        "ex_en": "At first Riley saw no worth in her drawings, but the people at her stand found real value in them.",
        "ex_es": "Al principio Riley no veía valor en sus dibujos, pero la gente de su puesto sí lo encontró.",
        "word_es": "valor"
      },
      {
        "word": "free",
        "def_en": "given without asking for money",
        "def_es": "que se da sin pedir dinero a cambio",
        "ex_en": "Riley's sign said FREE ART.",
        "ex_es": "El letrero de Riley decía ARTE GRATIS.",
        "word_es": "gratis"
      },
      {
        "word": "generosity",
        "def_en": "to give something to others",
        "def_es": "dar algo a los demás",
        "ex_en": "Riley showed generosity when she gave her art away.",
        "ex_es": "Riley mostró generosidad al regalar sus dibujos.",
        "word_es": "generosidad"
      },
      {
        "word": "confidence",
        "def_en": "believing in yourself and your abilities",
        "def_es": "creer en ti mismo y en lo que puedes hacer",
        "ex_en": "After the kids asked her to teach them, Riley felt her confidence grow.",
        "ex_es": "Cuando los niños le pidieron que les enseñara, la confianza de Riley creció.",
        "word_es": "confianza"
      },
      {
        "word": "gratitude",
        "def_en": "recognizing and being thankful for something good",
        "def_es": "darse cuenta de algo bueno y dar las gracias por ello",
        "ex_en": "Everyone who took a drawing thanked Riley with gratitude, and she began to smile.",
        "ex_es": "Todos los que se llevaron un dibujo le dieron las gracias a Riley con gratitud, y ella sonrió.",
        "word_es": "gratitud"
      }
    ],
    "title_es": "EL PUESTO DE ARTE DE RILEY",
    "summary_es": "Riley es una artista talentosa que esconde su trabajo porque cree que no es lo suficientemente bueno. Cuando Ellis descubre accidentalmente sus dibujos ocultos, él y sus amigos la convencen de compartirlos en un puesto de arte gratuito en la acera. Cuando los vecinos responden con alegría y le piden a Riley que les enseñe, ella descubre que su talento tiene un valor real, no en dinero, sino en la alegría y la conexión que trae a los demás.",
    "fl_pillar_es": "Las habilidades tienen valor, dar versus vender"
  },
  {
    "season": 1,
    "chapter": 6,
    "slug": "s1-ch06",
    "title": "THE PENNY HUNT",
    "summary": "Layla finds a single penny on the sidewalk and shares the discovery with her friends, who turn it into a week-long coin-hunting adventure. Ellis organizes their effort with a collection jar and careful record-keeping. When they count their haul and debate what to do with the money, Mister Mason shares a childhood memory about saving. The friends learn that small amounts add up over time and decide to keep saving together.",
    "fl_pillar": "Saving small amounts, counting money",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch6/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch6/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch6/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch6/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch6/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch6/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch6/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch6/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "save",
        "def_en": "to gather things together over time",
        "def_es": "Guardar dinero poco a poco para usarlo después",
        "ex_en": "The friends wanted to save pennies in a jar.",
        "ex_es": "Los amigos querían ahorrar centavos en un frasco.",
        "word_es": "ahorrar"
      },
      {
        "word": "order_form",
        "def_en": "to write something down so you remember it",
        "def_es": "Documento estructurado con espacios designados para registrar información específica",
        "ex_en": "Ellis's notebook was like a form to record the coins.",
        "ex_es": "El cuaderno de Ellis era como un formulario para anotar monedas.",
        "word_es": "formulario de pedido"
      },
      {
        "word": "division_of_labor",
        "def_en": "working together as a group",
        "def_es": "trabajar juntos en grupo",
        "ex_en": "The four friends used collaboration, sorting the coins together while Ellis counted and wrote the numbers down.",
        "ex_es": "Con división del trabajo, los cuatro separaron las monedas mientras Ellis contaba y apuntaba los números.",
        "word_es": "división del trabajo"
      },
      {
        "word": "inventory",
        "def_en": "a complete count of items you have",
        "def_es": "Productos que se preparan con anticipación para tenerlos listos cuando alguien los pida",
        "ex_en": "Ellis counted every group of coins and wrote the numbers, which was like an inventory of what they had.",
        "ex_es": "Ellis contó cada grupo de monedas y apuntó los números, como un inventario de todo lo que tenían.",
        "word_es": "inventario"
      },
      {
        "word": "organize",
        "def_en": "to arrange things in a helpful order",
        "def_es": "acomodar las cosas en un orden útil",
        "ex_en": "Ellis helped organize the coins into piles.",
        "ex_es": "Ellis ayudó a organizar las monedas en grupos.",
        "word_es": "organizar"
      },
      {
        "word": "perseverance",
        "def_en": "continuing to do something even when it takes time",
        "def_es": "seguir haciendo algo aunque tarde mucho",
        "ex_en": "It took perseverance to count every coin, but Ellis kept going until he had the whole total in his notebook.",
        "ex_es": "Contar todas las monedas requirió perseverancia, pero Ellis siguió hasta tener el total completo en su cuaderno.",
        "word_es": "perseverancia"
      }
    ],
    "title_es": "LA BÚSQUEDA DE CENTAVOS",
    "summary_es": "Layla encuentra un centavo en la acera y comparte el descubrimiento con sus amigos, quienes lo convierten en una aventura de búsqueda de monedas durante toda una semana. Ellis organiza el esfuerzo con un frasco de recolección y un registro cuidadoso. Cuando cuentan lo recaudado y debaten qué hacer con el dinero, Mister Mason comparte un recuerdo de su infancia sobre el ahorro. Los amigos aprenden que las cantidades pequeñas se acumulan con el tiempo y deciden seguir ahorrando juntos.",
    "fl_pillar_es": "Ahorrar cantidades pequeñas, contar dinero"
  },
  {
    "season": 1,
    "chapter": 7,
    "slug": "s1-ch07",
    "title": "THE SECRET FORT",
    "summary": "Ellis discovers a hidden clearing in the park, and the four friends decide to build a secret fort there. Their first attempts fail, but Mister Mason arrives with rope and teaches them building technique. Each friend contributes a unique strength, and they also incorporate found materials like fallen branches and a discarded blanket. They complete the fort and decide to share it, learning that resourcefulness and teamwork can create something valuable without spending any money.",
    "fl_pillar": "Using found materials, resourcefulness",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch7/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch7/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch7/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch7/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch7/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch7/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch7/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch7/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "resource",
        "def_en": "things you use to build or make something",
        "def_es": "Todo lo que se necesita para hacer algo: materiales, dinero, tiempo, esfuerzo",
        "ex_en": "Layla, Riley, Ellis and Benny needed materials for the fort.",
        "ex_es": "Layla, Riley, Ellis y Benny necesitaban materiales para el fuerte.",
        "word_es": "recurso"
      },
      {
        "word": "salvage",
        "def_en": "discovered or located without buying",
        "def_es": "encontrado sin tener que comprarlo",
        "ex_en": "The friends salvaged branches that fell in the park.",
        "ex_es": "Los amigos rescataron ramas caídas en el parque.",
        "word_es": "rescatar"
      },
      {
        "word": "structure",
        "def_en": "to build something using a plan",
        "def_es": "construir algo siguiendo un plan",
        "ex_en": "Following Ellis's plan, the friends leaned the long branches against trees and tied them with rope to build the structure.",
        "ex_es": "Siguiendo el plan de Ellis, los amigos apoyaron las ramas largas en los árboles y las ataron con cuerda para formar la estructura.",
        "word_es": "estructura"
      },
      {
        "word": "stability",
        "def_en": "the quality of being strong and not falling down",
        "def_es": "ser fuerte y no caerse",
        "ex_en": "Ellis explained that leaning the long branches against the trees would give the fort support and stability.",
        "ex_es": "Ellis explicó que apoyar las ramas largas en los árboles daría apoyo y estabilidad al fuerte.",
        "word_es": "estabilidad"
      }
    ],
    "title_es": "EL FUERTE SECRETO",
    "summary_es": "Ellis descubre un claro oculto en el parque, y los cuatro amigos deciden construir un fuerte secreto allí. Sus primeros intentos fracasan, pero Mister Mason llega con cuerda y les enseña técnicas de construcción. Cada amigo aporta una fortaleza única, y también incorporan materiales encontrados como ramas caídas y una manta descartada. Completan el fuerte y deciden compartirlo, aprendiendo que el ingenio y el trabajo en equipo pueden crear algo valioso sin gastar dinero.",
    "fl_pillar_es": "Usar materiales encontrados, ingenio"
  },
  {
    "season": 1,
    "chapter": 8,
    "slug": "s1-ch08",
    "title": "FRANCES'S RECIPE BOX",
    "summary": "The four friends are heading to the corner store for snacks when Frances invites them into her kitchen instead. She introduces her grandmother's recipe box and guides them through baking zucchini bread from garden-fresh ingredients. Along the way, Frances leads a cost comparison showing that homemade food costs far less and yields far more than store-bought. Benny, who started the chapter hungry for store snacks, ends it with a new appreciation for cooking from scratch.",
    "fl_pillar": "Homemade vs store-bought, cost comparison",
    "thumbnails": {
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch8/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch8/t4/es.jpeg"
      },
      "t2": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch8/t2/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch8/t2/en.jpeg"
      },
      "t3": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch8/t3/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch8/t3/en.jpeg"
      },
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch8/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch8/t1/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "value",
        "def_en": "getting good value for the money you spend",
        "def_es": "recibir algo que vale lo que pagaste",
        "ex_en": "Frances's lesson showed good value, because the same two dollars bought twelve slices instead of one muffin.",
        "ex_es": "La lección de Frances mostró buen valor, porque con los mismos dos dólares había doce rebanadas en vez de un panecillo.",
        "word_es": "valor"
      },
      {
        "word": "resource",
        "def_en": "the items you need to make something",
        "def_es": "Todo lo que se necesita para hacer algo: materiales, dinero, tiempo, esfuerzo",
        "ex_en": "Eggs, flour and sugar were the ingredients for the bread.",
        "ex_es": "Los huevos, la harina y el azúcar eran los ingredientes del pan.",
        "word_es": "recurso"
      },
      {
        "word": "cost",
        "def_en": "how much money something requires",
        "def_es": "cuánto dinero necesita algo",
        "ex_en": "Riley asked about the cost of making the bread.",
        "ex_es": "Riley preguntó cuál era el costo de hacer el pan.",
        "word_es": "costo"
      },
      {
        "word": "budget",
        "def_en": "a plan for how to spend money wisely",
        "def_es": "Estimación anticipada de cuánto costará un trabajo y cuánto se cobrará; el plan de gastos",
        "ex_en": "Frances made a small budget on paper, with the garden zucchini at zero dollars and the other ingredients at about two dollars.",
        "ex_es": "Frances hizo un pequeño presupuesto en papel, con el calabacín del jardín en cero dólares y los demás ingredientes en unos dos dólares.",
        "word_es": "presupuesto"
      },
      {
        "word": "calculate",
        "def_en": "to figure out using math",
        "def_es": "resolver algo usando matemáticas",
        "ex_en": "Frances got paper to calculate how much the bread cost.",
        "ex_es": "Frances buscó papel para calcular cuánto cuesta el pan.",
        "word_es": "calcular"
      },
      {
        "word": "homemade",
        "def_en": "made at home instead of bought from a store",
        "def_es": "hecho en casa en vez de comprado en la tienda",
        "ex_en": "The homemade bread had twelve slices.",
        "ex_es": "El pan hecho en casa tenía doce rebanadas.",
        "word_es": "hecho en casa"
      },
      {
        "word": "compare",
        "def_en": "looking at two things to see how they differ",
        "def_es": "mirar dos cosas para ver en qué se diferencian",
        "ex_en": "Frances helped the friends compare one muffin at two dollars with a whole loaf that cuts into twelve slices.",
        "ex_es": "Frances ayudó a los amigos a comparar un panecillo de dos dólares con un pan entero que da doce rebanadas.",
        "word_es": "comparar"
      }
    ],
    "title_es": "LA CAJA DE RECETAS DE FRANCES",
    "summary_es": "Los cuatro amigos van camino a la tienda de la esquina a comprar golosinas cuando Frances los invita a su cocina. Les presenta la caja de recetas de su abuela y los guía para hornear pan de calabacín con ingredientes frescos del jardín. En el camino, Frances dirige una comparación de costos que muestra que la comida casera cuesta mucho menos y rinde mucho más que la comprada en tienda. Benny, que comenzó el capítulo con hambre de golosinas de tienda, lo termina con una nueva apreciación por cocinar desde cero.",
    "fl_pillar_es": "Hecho en casa versus comprado en tienda, comparación de costos"
  },
  {
    "season": 1,
    "chapter": 9,
    "slug": "s1-ch09",
    "title": "THE REPAIR SHOP",
    "summary": "Benny accidentally breaks his most treasured toy and believes it is ruined forever. His friends rally around him and suggest visiting Mister Mason, who teaches them that broken things can be repaired instead of replaced. Each friend brings a broken item, and together they learn hands-on repair techniques. The chapter closes with all four friends carrying their restored possessions home, understanding that fixing things preserves both money and sentimental value.",
    "fl_pillar": "Repairing versus replacing — extending the life of possessions saves money and preserves sentimental value",
    "thumbnails": {
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch9/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch9/t4/es.jpeg"
      },
      "t1": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch9/t1/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch9/t1/en.jpeg"
      },
      "t2": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch9/t2/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch9/t2/en.jpeg"
      },
      "t3": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch9/t3/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch9/t3/en.jpeg"
      }
    },
    "vocab": [
      {
        "word": "value",
        "def_en": "how much something matters to you",
        "def_es": "lo que algo vale, no solo en dinero sino en cuánto ayuda a las personas",
        "ex_en": "Mister Mason told Ellis a torn cover does not change the value of the story inside.",
        "ex_es": "El señor Mason le dijo a Ellis que una portada rota no cambia el valor del cuento que hay dentro.",
        "word_es": "valor"
      },
      {
        "word": "resource",
        "def_en": "being clever about solving problems without spending money",
        "def_es": "Todo lo que se necesita para hacer algo: materiales, dinero, tiempo, esfuerzo",
        "ex_en": "Mister Mason fixed everything with simple materials, like glue, clear tape, and small pliers, so nothing new had to be bought.",
        "ex_es": "El señor Mason arregló todo con materiales sencillos, como pegamento, cinta transparente y pinzas pequeñas, sin comprar nada nuevo.",
        "word_es": "recurso"
      },
      {
        "word": "save",
        "def_en": "keeping money instead of spending it",
        "def_es": "Guardar dinero poco a poco para usarlo después",
        "ex_en": "Mister Mason said fixing saves money.",
        "ex_es": "El señor Mason dijo que arreglar ahorra dinero.",
        "word_es": "ahorrar"
      },
      {
        "word": "capacity_limit",
        "def_en": "to put in the trash",
        "def_es": "echar a la basura",
        "ex_en": "Benny thought his broken train was just waste.",
        "ex_es": "Benny pensó que tenía que tirar el tren a la basura.",
        "word_es": "límite de capacidad"
      },
      {
        "word": "repair",
        "def_en": "to repair something broken",
        "def_es": "arreglar algo roto",
        "ex_en": "Mister Mason can repair Benny's train.",
        "ex_es": "El señor Mason puede reparar el tren de Benny.",
        "word_es": "reparar"
      },
      {
        "word": "replace",
        "def_en": "to throw something away and buy a new one instead",
        "def_es": "tirar algo y, en su lugar, comprar uno nuevo",
        "ex_en": "Mister Mason explained that money cannot replace his grandfather's chair, so he fixes it instead of throwing it away.",
        "ex_es": "El señor Mason explicó que el dinero no puede reemplazar la silla de su abuelo, así que la arregla en vez de tirarla.",
        "word_es": "reemplazar"
      },
      {
        "word": "stewardship",
        "def_en": "taking good care of the things you own",
        "def_es": "cuidar bien las cosas que tienes",
        "ex_en": "Benny showed stewardship when he carried his fixed train home with great care.",
        "ex_es": "Benny mostró mayordomía al llevar a casa su tren arreglado con mucho cuidado.",
        "word_es": "mayordomía"
      }
    ],
    "title_es": "EL TALLER DE REPARACIÓN",
    "summary_es": "Benny rompe accidentalmente su juguete más preciado y cree que está arruinado para siempre. Sus amigos se unen a su lado y sugieren visitar a Mister Mason, quien les enseña que las cosas rotas se pueden reparar en lugar de reemplazar. Cada amigo trae un objeto roto, y juntos aprenden técnicas de reparación prácticas. El capítulo cierra con los cuatro amigos caminando a casa con sus posesiones restauradas, entendiendo que arreglar las cosas preserva tanto el dinero como el valor sentimental.",
    "fl_pillar_es": "Reparar versus reemplazar — extender la vida de las posesiones ahorra dinero y preserva el valor sentimental"
  },
  {
    "season": 1,
    "chapter": 10,
    "slug": "s1-ch10",
    "title": "THE LIBRARY ADVENTURE",
    "summary": "On a rainy day with nothing to do, Riley and Ellis consider buying something for entertainment but instead decide to visit the library. Miss Chen, the librarian, introduces them to the full range of free resources available -- books, craft kits, movies, community events, and homework help. Riley gravitates toward art while Ellis discovers nonfiction science. They leave loaded with borrowed materials, understanding that the library provides endless learning and entertainment without spending any money.",
    "fl_pillar": "Free community resources — the library provides books, craft kits, movies, events, and more at no cost, funded by the community",
    "thumbnails": {
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch10/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch10/t4/es.jpeg"
      },
      "t1": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch10/t1/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch10/t1/en.jpeg"
      },
      "t2": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch10/t2/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch10/t2/en.jpeg"
      },
      "t3": {
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch10/t3/es.jpeg",
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch10/t3/en.jpeg"
      }
    },
    "vocab": [
      {
        "word": "free",
        "def_en": "costs no money at all",
        "def_es": "que no cuesta nada de dinero",
        "ex_en": "Riley asked if the books were free.",
        "ex_es": "Riley preguntó si los libros eran gratis.",
        "word_es": "gratis"
      },
      {
        "word": "resource",
        "def_en": "something useful that you can use",
        "def_es": "Todo lo que se necesita para hacer algo: materiales, dinero, tiempo, esfuerzo",
        "ex_en": "Puzzles, movies, and craft kits are resources the library lends so anyone can use them.",
        "ex_es": "Los rompecabezas, las películas y los kits de manualidades son recursos que la biblioteca presta para que todos los usen.",
        "word_es": "recurso"
      },
      {
        "word": "borrow",
        "def_en": "a place to borrow books for free",
        "def_es": "un lugar para pedir libros prestados gratis",
        "ex_en": "Riley found out she could borrow a watercolor painting kit at the library, just like a book.",
        "ex_es": "Riley descubrió que podía pedir prestado un kit de acuarelas en la biblioteca, igual que un libro.",
        "word_es": "pedir prestado"
      },
      {
        "word": "community",
        "def_en": "all the people who live in a neighborhood together",
        "def_es": "todas las personas que viven juntas en un vecindario",
        "ex_en": "Miss Chen said the library belongs to the whole community.",
        "ex_es": "Miss Chen dijo que la biblioteca es de toda la comunidad.",
        "word_es": "comunidad"
      }
    ],
    "title_es": "LA AVENTURA DE LA BIBLIOTECA",
    "summary_es": "En un día lluvioso sin nada que hacer, Riley y Ellis consideran comprar algo para entretenerse pero en su lugar deciden visitar la biblioteca. Miss Chen, la bibliotecaria, les presenta la gama completa de recursos gratuitos disponibles: libros, kits de manualidades, películas, eventos comunitarios y ayuda con la tarea. Riley se inclina por el arte mientras Ellis descubre la ciencia de no ficción. Se van cargados de materiales prestados, entendiendo que la biblioteca ofrece aprendizaje y entretenimiento infinitos sin gastar dinero.",
    "fl_pillar_es": "Recursos comunitarios gratuitos — la biblioteca ofrece libros, kits de manualidades, películas, eventos y más sin costo, financiados por la comunidad"
  },
  {
    "season": 1,
    "chapter": 11,
    "slug": "s1-ch11",
    "title": "THE GIVING GARDEN",
    "summary": "Months after planting seeds with Frances, Layla returns to the garden and discovers an enormous harvest. She gathers her friends, and together they pick far more vegetables than they can use. Frances suggests sharing with the neighborhood. The children assemble gift baskets and deliver them door to door, and every neighbor reciprocates with a gift of their own. Frances ties the experience to the concept of investment -- small effort growing into abundance -- and the cycle of giving and receiving that strengthens a community.",
    "fl_pillar": "Investment paying off — time and effort invested in planting seeds yields a harvest; sharing creates community wealth and reciprocity",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch11/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch11/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch11/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch11/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch11/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch11/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch11/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch11/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "scarcity",
        "def_en": "when there is too little of something; abundance is when there is more than enough",
        "def_es": "Escasez es cuando hay muy poco de algo; abundancia es cuando hay mucho más de lo necesario",
        "ex_en": "Six full baskets showed there was abundance in the garden.",
        "ex_es": "Seis canastas llenas mostraban la abundancia del jardín.",
        "word_es": "escasez"
      },
      {
        "word": "investment",
        "def_en": "putting time or effort into something that grows",
        "def_es": "Poner algo de valor (tiempo, esfuerzo, dinero) con la esperanza de que crezca y produzca más",
        "ex_en": "Frances told the friends their time and care in the garden was an investment.",
        "ex_es": "Frances les dijo que su tiempo y su cuidado en el jardín fueron una inversión.",
        "word_es": "inversión"
      },
      {
        "word": "business_cycle",
        "def_en": "a pattern that repeats over and over again",
        "def_es": "Los pasos completos de un negocio o el patrón que se repite — incluyendo las temporadas altas y bajas",
        "ex_en": "Frances said each season builds on the last one, so the cycle of planting and harvest keeps going.",
        "ex_es": "Frances dijo que cada temporada se apoya en la anterior, así que el ciclo de sembrar y cosechar continúa.",
        "word_es": "ciclo de negocio"
      },
      {
        "word": "generosity",
        "def_en": "giving to others freely",
        "def_es": "dar a los demás sin pedir nada a cambio",
        "ex_en": "Layla showed generosity when she gave Missus Chen a basket.",
        "ex_es": "Layla mostró generosidad al darle una canasta a la señora Chen.",
        "word_es": "generosidad"
      },
      {
        "word": "harvest",
        "def_en": "gathering food that has grown",
        "def_es": "recoger la comida que ya creció",
        "ex_en": "Layla wanted to harvest the vegetables right away.",
        "ex_es": "Layla quería cosechar las verduras enseguida.",
        "word_es": "cosecha"
      }
    ],
    "title_es": "EL JARDÍN GENEROSO",
    "summary_es": "Meses después de plantar semillas con Frances, Layla regresa al jardín y descubre una cosecha enorme. Reúne a sus amigos, y juntos recogen muchos más vegetales de los que pueden usar. Frances sugiere compartir con el vecindario. Los niños arman canastas de regalo y las entregan puerta por puerta, y cada vecino responde con un regalo propio. Frances conecta la experiencia con el concepto de inversión — un pequeño esfuerzo que crece hasta convertirse en abundancia — y el ciclo de dar y recibir que fortalece a una comunidad.",
    "fl_pillar_es": "La inversión da frutos — el tiempo y esfuerzo invertidos en plantar semillas producen una cosecha; compartir crea riqueza comunitaria y reciprocidad"
  },
  {
    "season": 1,
    "chapter": 12,
    "slug": "s1-ch12",
    "title": "THE TREASURE EXHIBITION",
    "summary": "As summer ends, Layla surveys the treasures she and her friends have accumulated across the season and wishes she could share them. The four friends organize a Treasure Exhibition at the park pavilion, each contributing a display that represents a key lesson from the season: art, nature finds, home-grown vegetables, and repaired possessions. Neighborhood families attend, and the children teach younger kids that real treasures are free -- found, grown, made, or fixed rather than bought. Frances and Mister Mason arrive to celebrate the children with certificates. The chapter closes the season with the unifying message that valuable things do not require money, only awareness and creativity.",
    "fl_pillar": "Recognizing value in non-monetary treasures — everything the children found, made, grew, and repaired cost nothing; resourcefulness and creativity replace spending",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch12/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch12/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch12/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch12/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch12/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch12/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s1/ch12/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s1/ch12/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "value",
        "def_en": "something special and valuable to you, not just things that cost money",
        "def_es": "lo que algo vale, no solo en dinero sino en cuánto ayuda a las personas",
        "ex_en": "Layla learned that the best treasures are the ones we find and share, not things that cost money.",
        "ex_es": "Layla aprendió que lo que más valor tiene es lo que encontramos y compartimos, no lo que cuesta dinero.",
        "word_es": "valor"
      },
      {
        "word": "free",
        "def_en": "costs no money at all",
        "def_es": "que no cuesta nada de dinero",
        "ex_en": "Riley said her drawings were free for everyone.",
        "ex_es": "Riley dijo que sus dibujos eran gratis para todos.",
        "word_es": "gratis"
      },
      {
        "word": "scarcity",
        "def_en": "when there is too little of something; abundance is when there is more than enough",
        "def_es": "Escasez es cuando hay muy poco de algo; abundancia es cuando hay mucho más de lo necesario",
        "ex_en": "The tables at the exhibition overflowed with an abundance of treasures, from creek rocks and vegetables to repaired toys.",
        "ex_es": "Las mesas de la exhibición rebosaban de abundancia, con rocas del arroyo, vegetales y juguetes arreglados.",
        "word_es": "escasez"
      },
      {
        "word": "resource",
        "def_en": "being clever about finding and using what you need",
        "def_es": "Todo lo que se necesita para hacer algo: materiales, dinero, tiempo, esfuerzo",
        "ex_en": "Layla and Riley were resourceful, turning old cardboard boxes from the garage into display cases for the treasures.",
        "ex_es": "Layla y Riley usaron bien sus recursos y convirtieron cajas viejas de cartón del garaje en vitrinas para los tesoros.",
        "word_es": "recurso"
      },
      {
        "word": "display",
        "def_en": "a show where things are displayed",
        "def_es": "Muestra organizada de objetos para que otros los vean y los aprecien",
        "ex_en": "The friends reached the pavilion before anyone else to set up their exhibition on the long wooden tables.",
        "ex_es": "Los amigos llegaron al pabellón antes que nadie para armar su exhibición en las mesas largas de madera.",
        "word_es": "exhibición"
      },
      {
        "word": "generosity",
        "def_en": "to let others enjoy what you have",
        "def_es": "dejar que otros disfruten lo que tienes",
        "ex_en": "Riley showed generosity when she said her drawings were free for everyone.",
        "ex_es": "Riley mostró generosidad al decir que sus dibujos eran gratis para todos.",
        "word_es": "generosidad"
      },
      {
        "word": "repair",
        "def_en": "to fix something that is broken",
        "def_es": "arreglar algo que está roto",
        "ex_en": "Benny said they chose to repair the train and frame instead of throwing them away.",
        "ex_es": "Benny dijo que decidieron reparar el tren y el marco en vez de tirarlos.",
        "word_es": "reparar"
      },
      {
        "word": "community",
        "def_en": "all the people in your neighborhood",
        "def_es": "todas las personas de tu vecindario",
        "ex_en": "Neighbors from the whole community came to the pavilion and stood together at the same table.",
        "ex_es": "Vecinos de toda la comunidad llegaron al pabellón y se quedaron juntos en la misma mesa.",
        "word_es": "comunidad"
      }
    ],
    "title_es": "LA FERIA DEL TESORO",
    "summary_es": "Al terminar el verano, Layla observa los tesoros que ella y sus amigos acumularon durante la temporada y desea poder compartirlos. Los cuatro amigos organizan una Exhibición de Tesoros en el pabellón del parque, cada uno contribuyendo una muestra que representa una lección clave de la temporada: arte, hallazgos naturales, vegetales cultivados en casa y posesiones reparadas. Familias del vecindario asisten, y los niños les enseñan a los más pequeños que los verdaderos tesoros son gratuitos: encontrados, cultivados, hechos o arreglados en lugar de comprados. Frances y Mister Mason llegan para celebrar a los niños con certificados. El capítulo cierra la temporada con el mensaje unificador de que las cosas valiosas no requieren dinero, solo conciencia y creatividad.",
    "fl_pillar_es": "Reconocer el valor en tesoros no monetarios — todo lo que los niños encontraron, hicieron, cultivaron y repararon no costó nada; el ingenio y la creatividad reemplazan el gasto"
  },
  {
    "season": 2,
    "chapter": 1,
    "slug": "s2-ch01",
    "title": "THE SWAP MEET",
    "summary": "Layla spots a swap meet announcement and gathers her three friends to attend. Each friend selects unused items from home to bring for trading. At the community center, they learn the rule of fair exchange and discover how giving away old possessions can bring joy to new owners. The experience plants the seed of organizing larger community events together.",
    "fl_pillar": "Fair trade, exchange, value",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch1/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch1/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch1/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch1/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch1/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch1/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch1/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch1/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "value",
        "def_en": "the worth something has, not just in money but in how much it helps or matters to people",
        "def_es": "lo que algo vale, no solo en dinero sino en cuánto ayuda a las personas",
        "ex_en": "Ellis said value depends on the person, since everyone got something they wanted without spending a single dollar.",
        "ex_es": "Ellis dijo que el valor depende de cada persona, porque todos consiguieron algo que querían sin gastar dinero.",
        "word_es": "valor"
      },
      {
        "word": "planning",
        "def_en": "thinking carefully about what steps to take before starting work",
        "def_es": "Pensar y organizar lo que se va a hacer antes de hacerlo",
        "ex_en": "The friends started planning what old things to bring to the swap meet.",
        "ex_es": "Los amigos empezaron a planificar qué cosas viejas llevar al mercado de trueque.",
        "word_es": "planificación"
      },
      {
        "word": "supply_and_demand",
        "def_en": "the relationship between how much of something exists and how many people want it — scarcity raises price, oversupply lowers it",
        "def_es": "Principio económico: cuando hay poco de algo y mucha gente lo quiere, el precio sube; cuando hay mucho (sobreoferta), baja",
        "ex_en": "Riley had several colored pencils to swap, and that supply was just right for the grandchildren.",
        "ex_es": "Riley tenía varios lápices de colores para intercambiar, y esa oferta era justa para los nietos.",
        "word_es": "oferta y demanda"
      },
      {
        "word": "display",
        "def_en": "the way you arrange and present items to attract buyers; a public showing of what you offer",
        "def_es": "Muestra organizada de objetos para que otros los vean y los aprecien",
        "ex_en": "Ellis suggested sorting their display by category, so people could browse the items more easily.",
        "ex_es": "Ellis propuso ordenar la exhibición por categorías para que la gente viera mejor las cosas.",
        "word_es": "exhibición"
      },
      {
        "word": "trade_barter",
        "def_en": "trading items back and forth; when no money changes hands it is called a barter",
        "def_es": "Cambiar una cosa por otra (trueque, sin dinero) o entregar un producto a cambio de dinero (transacción)",
        "ex_en": "Riley traded her colored pencils to the lady for watercolor paints.",
        "ex_es": "Riley cambió sus lápices de colores por las acuarelas, un trueque sin dinero.",
        "word_es": "trueque"
      }
    ],
    "title_es": "EL MERCADO DE TRUEQUES",
    "summary_es": "Layla ve un anuncio de un evento de intercambio y reúne a sus tres amigos para asistir. Cada amigo selecciona artículos sin usar de su casa para llevar al intercambio. En el centro comunitario, aprenden la regla del intercambio justo y descubren cómo regalar posesiones viejas puede traer alegría a nuevos dueños. La experiencia planta la semilla de organizar eventos comunitarios más grandes juntos.",
    "fl_pillar_es": "Comercio justo, intercambio, valor"
  },
  {
    "season": 2,
    "chapter": 2,
    "slug": "s2-ch02",
    "title": "THE LEMONADE PROBLEM",
    "summary": "On the hottest day of summer, Layla sets up a lemonade stand only to discover that five other kids -- including her three friends -- had the same idea. With too many sellers and too few buyers, nobody makes any sales, and a price war breaks out. Ellis diagnoses the oversupply problem, and Layla proposes combining into one stand. Working together, they attract customers and earn more than any single stand could have. The experience teaches them that variety, not duplication, will be the key to their future Community Market.",
    "fl_pillar": "Supply and demand",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch2/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch2/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch2/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch2/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch2/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch2/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch2/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch2/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "profit",
        "def_en": "the money you keep after paying all your costs",
        "def_es": "El dinero que queda después de restar todos los gastos de lo que se vendió",
        "ex_en": "Layla and her friends were happy to make more profit together than alone.",
        "ex_es": "Layla y sus amigos se alegraron de tener más ganancia juntos que por separado.",
        "word_es": "ganancia"
      },
      {
        "word": "customer",
        "def_en": "a person who pays you for something you make or fix",
        "def_es": "Persona que compra o podría comprar lo que vendes",
        "ex_en": "Layla set out her cups and sign, and waited for customers.",
        "ex_es": "Layla puso sus vasos y su letrero, y esperó a los clientes.",
        "word_es": "cliente"
      },
      {
        "word": "competition",
        "def_en": "when two or more businesses sell the same thing to the same customers",
        "def_es": "Cuando otra persona o negocio ofrece lo mismo que tú; la ventaja competitiva es la fortaleza que te hace ganar",
        "ex_en": "Six lemonade stands on one street meant a lot of competition for the same customers.",
        "ex_es": "Seis puestos de limonada en una calle eran mucha competencia por los mismos clientes.",
        "word_es": "competencia"
      },
      {
        "word": "display",
        "def_en": "arranging items so people can find and look at them easily",
        "def_es": "Muestra organizada de objetos para que otros los vean y los aprecien",
        "ex_en": "Layla made a neat display of paper cups in rows on her table.",
        "ex_es": "Layla hizo una exhibición ordenada de vasos de papel en su mesa.",
        "word_es": "exhibición"
      }
    ],
    "title_es": "EL PROBLEMA DE LA LIMONADA",
    "summary_es": "En el día más caluroso del verano, Layla monta un puesto de limonada solo para descubrir que otros cinco niños — incluidos sus tres amigos — tuvieron la misma idea. Con demasiados vendedores y muy pocos compradores, nadie logra vender nada, y estalla una guerra de precios. Ellis diagnostica el problema de sobreoferta, y Layla propone unirse en un solo puesto. Trabajando juntos, atraen clientes y ganan más de lo que cualquier puesto individual habría logrado. La experiencia les enseña que la variedad, no la duplicación, será la clave de su futuro Mercado Comunitario.",
    "fl_pillar_es": "Oferta y demanda"
  },
  {
    "season": 2,
    "chapter": 3,
    "slug": "s2-ch03",
    "title": "THE BUSY SATURDAY",
    "summary": "The four friends are approached by multiple neighbors needing help on the same Saturday morning. When they try to tackle the first job as an undifferentiated group, they get in each other's way and make little progress. Ellis suggests that each person take a separate role based on their individual strengths. This division of labor transforms their efficiency, allowing them to complete three large jobs before noon. The experience teaches them that specialization makes teams more effective and inspires them to apply the same principle to their future Community Market.",
    "fl_pillar": "Specialization, division of labor",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch3/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch3/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch3/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch3/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch3/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch3/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch3/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch3/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "free",
        "def_en": "costing nothing; something given as a gift or available at no charge",
        "def_es": "que no cuesta nada; algo que se da como regalo o sin cobrar",
        "ex_en": "On a free Saturday morning, Layla and her friends gave their time to help Missus Patterson, Frances and Mister Johnson.",
        "ex_es": "Una mañana libre de sábado, Layla y sus amigos regalaron su tiempo para ayudar a la señora Patterson, a Frances y al señor Johnson.",
        "word_es": "gratis"
      },
      {
        "word": "planning",
        "def_en": "thinking carefully about what steps to take before starting work",
        "def_es": "Pensar y organizar lo que se va a hacer antes de hacerlo",
        "ex_en": "The friends did their planning on the way to Frances's garden, and everyone agreed right away.",
        "ex_es": "Los amigos hicieron su planificación camino al jardín de Frances, y todos estuvieron de acuerdo.",
        "word_es": "planificación"
      },
      {
        "word": "division_of_labor",
        "def_en": "splitting up work so everyone does what they are best at",
        "def_es": "Organización en la que cada persona se dedica a la tarea que mejor sabe hacer, logrando más con menos esfuerzo",
        "ex_en": "Ellis could focus because he had just one job to do.",
        "ex_es": "Con la división del trabajo, Ellis tenía un solo trabajo y no se confundía.",
        "word_es": "división del trabajo"
      },
      {
        "word": "inventory",
        "def_en": "a supply of goods made or purchased in advance and kept ready for sale",
        "def_es": "Productos que se preparan con anticipación para tenerlos listos cuando alguien los pida",
        "ex_en": "Ellis said he could manage the inventory for the market and track the numbers accurately.",
        "ex_es": "Ellis dijo que podía controlar el inventario del mercado y llevar bien las cuentas.",
        "word_es": "inventario"
      },
      {
        "word": "trade_barter",
        "def_en": "exchanging goods or services — in a barter no money is used; in a transaction, money changes hands",
        "def_es": "Cambiar una cosa por otra (trueque, sin dinero) o entregar un producto a cambio de dinero (transacción)",
        "ex_en": "Layla remembered the swap meet and said they should not all bring identical items to sell.",
        "ex_es": "Layla recordó el mercado de trueque y dijo que no todos debían llevar cosas idénticas para vender.",
        "word_es": "trueque"
      }
    ],
    "title_es": "EL SÁBADO OCUPADO",
    "summary_es": "Los cuatro amigos son abordados por múltiples vecinos que necesitan ayuda el mismo sábado por la mañana. Cuando intentan abordar el primer trabajo como un grupo indiferenciado, se estorban mutuamente y avanzan poco. Ellis sugiere que cada persona asuma un rol separado basado en sus fortalezas individuales. Esta división del trabajo transforma su eficiencia, permitiéndoles completar tres grandes trabajos antes del mediodía. La experiencia les enseña que la especialización hace a los equipos más eficaces y los inspira a aplicar el mismo principio a su futuro Mercado Comunitario.",
    "fl_pillar_es": "Especialización, división del trabajo"
  },
  {
    "season": 2,
    "chapter": 4,
    "slug": "s2-ch04",
    "title": "MR. MASON'S TRUNK",
    "summary": "The four friends visit Mister Mason's house to help him clean his attic. While organizing, Ellis discovers a leather trunk covered in travel stickers from around the world. Mister Mason opens it to reveal a collection of objects, each tied to a market or economic lesson from a different country. As the friends each discover an item and hear its story, they realize these are not mere souvenirs but encoded lessons about trade, auctions, costs, and timing. Mister Mason declares he has been saving these lessons for the right people, and the chapter closes with the beginning of his first full story -- the markets of Morocco.",
    "fl_pillar": "Objects carry stories and economic lessons; introduction to global marketplaces",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch4/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch4/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch4/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch4/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch4/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch4/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch4/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch4/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "value",
        "def_en": "the worth something has, not just in money but in how much it helps or matters to people",
        "def_es": "lo que algo vale, no solo en dinero sino en cuánto ayuda a las personas",
        "ex_en": "The golden star Layla held had great value, because skilled hands made it for a Christmas market in Germany.",
        "ex_es": "La estrella dorada que sostuvo Layla tenía gran valor, pues unas manos hábiles la hicieron para un mercado de Navidad en Alemania.",
        "word_es": "valor"
      },
      {
        "word": "negotiate",
        "def_en": "going back and forth in conversation to reach an agreement",
        "def_es": "Hablar sobre el precio hasta llegar a un acuerdo justo entre dos personas",
        "ex_en": "In Morocco, Mister Mason learned to negotiate fair prices with the spice merchants.",
        "ex_es": "En Marruecos, el señor Mason aprendió a negociar precios justos con los comerciantes.",
        "word_es": "negociar"
      },
      {
        "word": "order_request",
        "def_en": "a customer's request for a product or service — including pre-orders paid before the item is made",
        "def_es": "Encargos que alguien te hace para que le hagas o le traigas algo — incluyendo prepedidos pagados por adelantado",
        "ex_en": "Mister Mason made a simple request for help reaching items in his attic, and the four friends agreed.",
        "ex_es": "El señor Mason hizo un pedido sencillo de ayuda para alcanzar cosas en su ático, y los cuatro amigos aceptaron.",
        "word_es": "pedidos"
      },
      {
        "word": "craftsmanship",
        "def_en": "the skill of making things well by hand, learned with lots of practice",
        "def_es": "Trabajo especializado que se aprende con práctica durante años",
        "ex_en": "Benny turned the wooden stamp over and saw how remarkable the craftsmanship was.",
        "ex_es": "Benny volteó el sello de madera y vio qué notable era la artesanía.",
        "word_es": "artesanía"
      }
    ],
    "title_es": "EL BAÚL DEL SR. MASON",
    "summary_es": "Los cuatro amigos visitan la casa de Mister Mason para ayudarlo a limpiar su ático. Mientras organizan, Ellis descubre un baúl de cuero cubierto de calcomanías de viaje de ciudades de todo el mundo. Mister Mason lo abre para revelar una colección de objetos, cada uno ligado a un mercado o lección económica de un país diferente. Mientras los amigos descubren un objeto cada uno y escuchan su historia, se dan cuenta de que no son simples recuerdos sino lecciones codificadas sobre comercio, subastas, costos y tiempos. Mister Mason declara que ha estado guardando estas lecciones para las personas indicadas, y el capítulo cierra con el comienzo de su primera historia completa — los mercados de Marruecos.",
    "fl_pillar_es": "Los objetos cargan historias y lecciones económicas; introducción a los mercados globales"
  },
  {
    "season": 2,
    "chapter": 5,
    "slug": "s2-ch05",
    "title": "THE SPICE MARKET",
    "summary": "Mister Mason opens a pouch of exotic spices from his trunk and transports the friends into a memory of a Moroccan spice market. He recounts how he learned to negotiate by walking away from a high opening price, comparing stalls, and arriving at a fair deal with a merchant. The lesson expands into supply and demand when he explains how a saffron shortage raised prices while abundant pepper stayed cheap. Layla synthesizes the lesson, connecting negotiation and fairness to their upcoming Community Market.",
    "fl_pillar": "Negotiation, fair price, supply and demand",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch5/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch5/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch5/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch5/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch5/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch5/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch5/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch5/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "value",
        "def_en": "how much something is worth — which can depend on who needs it",
        "def_es": "lo que algo vale, no solo en dinero sino en cuánto ayuda a las personas",
        "ex_en": "That saffron had special value to Mister Mason for his cooking.",
        "ex_es": "Ese azafrán tenía un valor especial para el señor Mason y su cocina.",
        "word_es": "valor"
      },
      {
        "word": "free",
        "def_en": "something given or gotten without paying any money",
        "def_es": "algo que se da o se recibe sin pagar dinero",
        "ex_en": "The merchant added free cumin, and the two men shook hands.",
        "ex_es": "El comerciante le regaló comino, y los dos se dieron la mano.",
        "word_es": "gratis"
      },
      {
        "word": "cost",
        "def_en": "the money needed to make or do something",
        "def_es": "el dinero que se necesita para hacer algo",
        "ex_en": "The cost of black pepper was low because every stall had mountains of it.",
        "ex_es": "El costo de la pimienta negra fue bajo porque todos los puestos tenían montañas.",
        "word_es": "costo"
      },
      {
        "word": "budget",
        "def_en": "a spending plan that tracks income and expenses so you don't run out of money",
        "def_es": "Estimación anticipada de cuánto costará un trabajo y cuánto se cobrará; el plan de gastos",
        "ex_en": "Mister Mason had a limited student budget, so he wanted a fair price for the saffron.",
        "ex_es": "El señor Mason tenía un presupuesto de estudiante limitado, así que quería un precio justo por el azafrán.",
        "word_es": "presupuesto"
      },
      {
        "word": "quality",
        "def_en": "how well crafted something is and how reliably it performs — the standard customers expect",
        "def_es": "Que algo esté bien hecho, con cuidado, y que dure mucho tiempo",
        "ex_en": "Mister Mason wanted the best quality saffron he could afford, because his mother had asked for the good stuff.",
        "ex_es": "El señor Mason quería azafrán de la mejor calidad que pudiera pagar, porque su madre le pidió lo bueno.",
        "word_es": "calidad"
      },
      {
        "word": "competition",
        "def_en": "when two or more businesses sell the same thing to the same customers",
        "def_es": "Cuando otra persona o negocio ofrece lo mismo que tú; la ventaja competitiva es la fortaleza que te hace ganar",
        "ex_en": "Merchants shouted in fierce competition for every customer passing by.",
        "ex_es": "Los comerciantes gritaban en una fuerte competencia por cada cliente que pasaba.",
        "word_es": "competencia"
      }
    ],
    "title_es": "EL MERCADO DE ESPECIAS",
    "summary_es": "Mister Mason abre una bolsa de especias exóticas de su baúl y transporta a los amigos a un recuerdo de un mercado de especias marroquí. Relata cómo aprendió a negociar al alejarse de un precio inicial alto, comparar puestos y llegar a un trato justo con un comerciante. La lección se expande hacia la oferta y la demanda cuando explica cómo una escasez de azafrán elevó los precios mientras que la pimienta abundante se mantuvo barata. Layla sintetiza la lección, conectando la negociación y la justicia con su próximo Mercado Comunitario.",
    "fl_pillar_es": "Negociación, precio justo, oferta y demanda"
  },
  {
    "season": 2,
    "chapter": 6,
    "slug": "s2-ch06",
    "title": "THE FISH AUCTION",
    "summary": "Mister Mason pulls a small carved wooden fish from his trunk and remembers a fish market in Japan. Young Mister Mason watches a tuna auction, where buyers bid against each other and the price climbs higher and higher. A buyer tells him that in an auction the buyers decide the price, not the seller. Back in the attic, Ellis sees that it is the opposite of their lemonade stand: too many sellers pushed prices down, but many buyers push prices up. Riley suggests an auction with play coins for their Community Market.",
    "fl_pillar": "Auctions, bidding, competition between buyers sets the price",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch6/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch6/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch6/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch6/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch6/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch6/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch6/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch6/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "free",
        "def_en": "something given or gotten without paying any money",
        "def_es": "algo que se da o se recibe sin pagar dinero",
        "ex_en": "Mister Mason paid for the little wooden fish, so it was not free.",
        "ex_es": "El señor Mason pagó el pececito de madera, así que no era gratis.",
        "word_es": "gratis"
      },
      {
        "word": "profit",
        "def_en": "the money left over after you pay for what you used",
        "def_es": "El dinero que queda después de restar todos los gastos de lo que se vendió",
        "ex_en": "A high tuna price could mean profit for the seller.",
        "ex_es": "Un precio alto por el atún puede dar ganancia al vendedor.",
        "word_es": "ganancia"
      },
      {
        "word": "cost",
        "def_en": "the money needed to make or do something",
        "def_es": "el dinero que se necesita para hacer algo",
        "ex_en": "Young Mister Mason could not believe the cost of one single fish.",
        "ex_es": "El joven señor Mason no podía creer el costo de un solo pescado.",
        "word_es": "costo"
      },
      {
        "word": "quality",
        "def_en": "how well crafted something is and how reliably it performs — the standard customers expect",
        "def_es": "Que algo esté bien hecho, con cuidado, y que dure mucho tiempo",
        "ex_en": "Workers checked each tuna with flashlights for quality and freshness.",
        "ex_es": "Los trabajadores revisaban cada atún con linternas para ver su calidad y su frescura.",
        "word_es": "calidad"
      }
    ],
    "title_es": "LA SUBASTA DE PESCADO",
    "summary_es": "Mister Mason saca de su baúl un pececito de madera tallado y recuerda un mercado de pescado en Japón. El joven Mister Mason ve una subasta de atún, donde los compradores ofrecen más y más dinero unos contra otros y el precio sube cada vez más. Un comprador le explica que en una subasta los compradores deciden el precio, no el vendedor. De vuelta en el ático, Ellis se da cuenta de que es lo contrario de su puesto de limonada: demasiados vendedores hicieron bajar los precios, pero muchos compradores los hacen subir. Riley propone hacer una subasta con monedas de juguete en su Mercado Comunitario.",
    "fl_pillar_es": "Subastas, ofertas, la competencia entre compradores fija el precio"
  },
  {
    "season": 2,
    "chapter": 7,
    "slug": "s2-ch07",
    "title": "THE FAMILY BAKERY",
    "summary": "Mister Mason produces a carved wooden bread stamp from his trunk and tells the story of the Rossi family bakery in Italy — a business passed through three generations. He recounts how Antonio broke down every hidden cost behind a two-euro loaf of bread: ingredients, electricity, and rent. The friends work through the math and discover that the profit per loaf is razor-thin. The lesson expands into why pricing too low kills a business and pricing too high drives customers away, leading to the concept of a balanced fair price. Benny applies the lesson to their Community Market.",
    "fl_pillar": "Costs, pricing, profit",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch7/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch7/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch7/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch7/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch7/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch7/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch7/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch7/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "value",
        "def_en": "how much something matters to you, not just its price",
        "def_es": "lo que algo vale, no solo en dinero sino en cuánto ayuda a las personas",
        "ex_en": "Mister Mason said a good business explains its value.",
        "ex_es": "El señor Mason dijo que un buen negocio explica su valor.",
        "word_es": "valor"
      },
      {
        "word": "free",
        "def_en": "costing nothing; something given as a gift or available at no charge",
        "def_es": "que no cuesta nada; algo que se da como regalo o sin cobrar",
        "ex_en": "On his last day, Antonio gave him the bread stamp as a gift.",
        "ex_es": "El último día, Antonio le regaló el sello de pan.",
        "word_es": "gratis"
      },
      {
        "word": "resource",
        "def_en": "the things you need to make something",
        "def_es": "Todo lo que se necesita para hacer algo: materiales, dinero, tiempo, esfuerzo",
        "ex_en": "Flour and yeast are ingredients for Antonio's bread.",
        "ex_es": "La harina y la levadura son ingredientes del pan de Antonio.",
        "word_es": "recurso"
      },
      {
        "word": "pricing",
        "def_en": "figuring out the right price to charge customers",
        "def_es": "La decisión estratégica de fijar precios para comunicar calidad y tipo de cliente",
        "ex_en": "Antonio had to think about pricing to cover flour and rent.",
        "ex_es": "Antonio tuvo que fijar precios para cubrir la harina y el alquiler.",
        "word_es": "fijar precios"
      },
      {
        "word": "quality",
        "def_en": "how good something is",
        "def_es": "Que algo esté bien hecho, con cuidado, y que dure mucho tiempo",
        "ex_en": "The family chose quality and used good flour.",
        "ex_es": "La familia eligió la calidad y usó buena harina.",
        "word_es": "calidad"
      },
      {
        "word": "division_of_labor",
        "def_en": "organizing work so each person specializes in one task, which makes the whole team more efficient",
        "def_es": "Organización en la que cada persona se dedica a la tarea que mejor sabe hacer, logrando más con menos esfuerzo",
        "ex_en": "Maria shaped the loaves while Antonio tended the oven, a clear division of labor.",
        "ex_es": "Maria daba forma a las hogazas mientras Antonio cuidaba el horno, una clara división del trabajo.",
        "word_es": "división del trabajo"
      }
    ],
    "title_es": "LA PANADERÍA FAMILIAR",
    "summary_es": "Mister Mason saca un sello de pan tallado en madera de su baúl y cuenta la historia de la panadería de la familia Rossi en Italia, un negocio transmitido por tres generaciones. Relata cómo Antonio desglosó cada costo oculto detrás de una hogaza de pan de dos euros: ingredientes, electricidad y alquiler. Los amigos hacen las cuentas y descubren que la ganancia por hogaza es mínima. La lección se amplía a por qué cobrar demasiado poco mata un negocio y cobrar demasiado ahuyenta a los clientes, llevando al concepto de un precio justo y equilibrado. Benny aplica la lección a su Mercado Comunitario.",
    "fl_pillar_es": "Costos, fijación de precios, ganancia"
  },
  {
    "season": 2,
    "chapter": 8,
    "slug": "s2-ch08",
    "title": "THE MORNING MARKET",
    "summary": "Mister Mason lifts a small fishing net from his trunk and transports the friends to a Greek fishing village. He tells the story of Dimitri, an old fisherman who must sell his entire daily catch before it spoils. Throughout the day, Dimitri progressively lowers his prices as the hours pass — from full price at dawn to nearly free by late afternoon — because fish are perishable and have no value the next day. The friends debate the fairness of bargain shoppers, learn why perishable goods require flexible pricing, and connect the lesson to time-sensitive products they might sell at their Community Market.",
    "fl_pillar": "Timing, perishable goods, urgency",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch8/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch8/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch8/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch8/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch8/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch8/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch8/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch8/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "free",
        "def_en": "costing no money",
        "def_es": "que no cuesta dinero",
        "ex_en": "Dimitri gave the last fish to a neighbor free.",
        "ex_es": "Dimitri le dio el último pescado a un vecino gratis.",
        "word_es": "gratis"
      },
      {
        "word": "profit",
        "def_en": "the money that remains after all costs are paid — what the business actually earned",
        "def_es": "El dinero que queda después de restar todos los gastos de lo que se vendió",
        "ex_en": "When the price fell to half, young Mister Mason worried about the fisherman's profits.",
        "ex_es": "Cuando el precio bajó a la mitad, al joven señor Mason le preocupaban las ganancias del pescador.",
        "word_es": "ganancia"
      },
      {
        "word": "save",
        "def_en": "keeping money or things instead of using them right away",
        "def_es": "Guardar dinero poco a poco para usarlo después",
        "ex_en": "The old woman waited to save money on fish.",
        "ex_es": "La señora esperó para ahorrar dinero en el pescado.",
        "word_es": "ahorrar"
      },
      {
        "word": "budget",
        "def_en": "a spending plan that tracks income and expenses so you don't run out of money",
        "def_es": "Estimación anticipada de cuánto costará un trabajo y cuánto se cobrará; el plan de gastos",
        "ex_en": "The old woman used her knowledge cleverly to protect her family budget.",
        "ex_es": "La señora usó su conocimiento con astucia para cuidar el presupuesto de su familia.",
        "word_es": "presupuesto"
      },
      {
        "word": "pricing",
        "def_en": "the strategy of setting prices to cover costs, earn profit, and signal quality to customers",
        "def_es": "La decisión estratégica de fijar precios para comunicar calidad y tipo de cliente",
        "ex_en": "Dimitri's pricing fell all day, from ten euros per kilogram in the morning to one euro by five o'clock.",
        "ex_es": "Dimitri tuvo que fijar precios más bajos durante el día, de diez euros el kilo a un euro a las cinco.",
        "word_es": "fijar precios"
      },
      {
        "word": "quality",
        "def_en": "how well made something is — good quality means it is done carefully and lasts a long time",
        "def_es": "Que algo esté bien hecho, con cuidado, y que dure mucho tiempo",
        "ex_en": "The high quality of the silver fish was obvious to everyone who looked.",
        "ex_es": "La alta calidad de los pescados plateados era obvia para todos los que miraban.",
        "word_es": "calidad"
      },
      {
        "word": "capacity_limit",
        "def_en": "using more than you need or throwing things away that could be used",
        "def_es": "usar más de lo que necesitas o tirar cosas que aún sirven",
        "ex_en": "Fish left until tomorrow would become waste.",
        "ex_es": "El pescado que sobrara hasta mañana sería un desperdicio.",
        "word_es": "límite de capacidad"
      },
      {
        "word": "display",
        "def_en": "the way you arrange and present items to attract buyers; a public showing of what you offer",
        "def_es": "Muestra organizada de objetos para que otros los vean y los aprecien",
        "ex_en": "Dimitri put the silver fish on ice with careful attention to display, so customers would stop and look.",
        "ex_es": "Dimitri puso los pescados plateados sobre el hielo con mucho cuidado en la exhibición, para que los clientes se detuvieran a mirar.",
        "word_es": "exhibición"
      },
      {
        "word": "trade_barter",
        "def_en": "exchanging goods or services — in a barter no money is used; in a transaction, money changes hands",
        "def_es": "Cambiar una cosa por otra (trueque, sin dinero) o entregar un producto a cambio de dinero (transacción)",
        "ex_en": "Dimitri gave the last fish to his neighbor, so no money changed hands in that exchange.",
        "ex_es": "Dimitri le dio el último pescado a su vecino, y en ese intercambio no se pagó dinero.",
        "word_es": "trueque"
      },
      {
        "word": "craftsmanship",
        "def_en": "the ability to make things carefully and well",
        "def_es": "Trabajo especializado que se aprende con práctica durante años",
        "ex_en": "The threads of the net were woven with great skill.",
        "ex_es": "Los hilos de la red estaban tejidos con mucho oficio.",
        "word_es": "artesanía"
      }
    ],
    "title_es": "EL MERCADO DE LA MAÑANA",
    "summary_es": "Mister Mason saca una pequeña red de pesca de su baúl y transporta a los amigos a un pueblo pesquero griego. Cuenta la historia de Dimitri, un viejo pescador que debe vender toda su pesca diaria antes de que se eche a perder. A lo largo del día, Dimitri baja progresivamente sus precios conforme pasan las horas, desde el precio completo al amanecer hasta casi gratis a media tarde, porque el pescado es perecedero y no tiene valor al día siguiente. Los amigos debaten la justicia de los compradores que esperan las rebajas, aprenden por qué los bienes perecederos requieren precios flexibles y conectan la lección con productos sensibles al tiempo que podrían vender en su Mercado Comunitario.",
    "fl_pillar_es": "Tiempo, bienes perecederos, urgencia"
  },
  {
    "season": 2,
    "chapter": 9,
    "slug": "s2-ch09",
    "title": "LA VECINA'S GARDEN",
    "summary": "The friends discover an abandoned, trash-filled empty lot and Layla proposes transforming it into a community garden. With Frances as their mentor and neighbors contributing tools and labor, they clear the lot, plant individual plots, and tend the garden daily. When the harvest yields more than they can use, they share the produce freely with neighbors, who in turn donate money for future seeds. The experience teaches them that sharing resources and cooperating benefits the entire community.",
    "fl_pillar": "Sharing resources, cooperation, community benefit",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch9/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch9/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch9/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch9/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch9/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch9/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch9/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch9/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "free",
        "def_en": "costing no money",
        "def_es": "que no cuesta dinero",
        "ex_en": "The sign said Free Garden Food For Everyone.",
        "ex_es": "El letrero decía Comida gratis del jardín para todos.",
        "word_es": "gratis"
      },
      {
        "word": "competition",
        "def_en": "when businesses compete for the same customers — and a competitive advantage is the special strength that helps one win",
        "def_es": "Cuando otra persona o negocio ofrece lo mismo que tú; la ventaja competitiva es la fortaleza que te hace ganar",
        "ex_en": "Layla said the market should work like the garden, with everyone helping each other and no competition.",
        "ex_es": "Layla dijo que el mercado debía ser como el jardín, donde todos se ayudan y no hay competencia.",
        "word_es": "competencia"
      },
      {
        "word": "display",
        "def_en": "arranging items so people can find and look at them easily",
        "def_es": "Muestra organizada de objetos para que otros los vean y los aprecien",
        "ex_en": "The friends set a table at the garden entrance for the vegetable display.",
        "ex_es": "Los amigos pusieron una mesa en la entrada del jardín para la exhibición de verduras.",
        "word_es": "exhibición"
      },
      {
        "word": "practice",
        "def_en": "doing something repeatedly until you improve and your body learns to do it naturally",
        "def_es": "Cuando el cuerpo recuerda cómo hacer algo por haberlo practicado, sin necesidad de pensarlo",
        "ex_en": "Frances knew lots about gardens from many years of experience and practice.",
        "ex_es": "Frances sabía mucho de jardines por muchos años de experiencia y práctica.",
        "word_es": "práctica"
      }
    ],
    "title_es": "EL JARDÍN DE LA VECINA",
    "summary_es": "Los amigos descubren un lote vacío abandonado y lleno de basura, y Layla propone transformarlo en un jardín comunitario. Con Frances como mentora y los vecinos contribuyendo herramientas y trabajo, limpian el lote, plantan parcelas individuales y cuidan el jardín a diario. Cuando la cosecha produce más de lo que pueden consumir, comparten los productos libremente con los vecinos, quienes a su vez donan dinero para semillas futuras. La experiencia les enseña que compartir recursos y cooperar beneficia a toda la comunidad.",
    "fl_pillar_es": "Compartir recursos, cooperación, beneficio comunitario"
  },
  {
    "season": 2,
    "chapter": 10,
    "slug": "s2-ch10",
    "title": "THE CHRISTMAS MARKET",
    "summary": "Mister Mason shows the friends a hand-carved wooden star from a German Christmas market and tells the story of meeting the woman who made it. Through her demonstration of the time, skill, and materials required to carve a single star, young Mister Mason learned why handmade goods cost more than factory-produced alternatives. Riley internalizes the lesson and resolves to factor her own time, skill, and materials into pricing her handmade crafts for the friends' upcoming market.",
    "fl_pillar": "Handmade goods, time value, craftsmanship pricing, uniqueness versus mass production",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch10/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch10/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch10/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch10/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch10/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch10/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch10/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch10/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "value",
        "def_en": "how much something matters to you, not just its price",
        "def_es": "lo que algo vale, no solo en dinero sino en cuánto ayuda a las personas",
        "ex_en": "The woman who sold ornaments said her time has value.",
        "ex_es": "La mujer que vendía adornos dijo que su tiempo tiene valor.",
        "word_es": "valor"
      },
      {
        "word": "resource",
        "def_en": "the things you need to make something",
        "def_es": "Todo lo que se necesita para hacer algo: materiales, dinero, tiempo, esfuerzo",
        "ex_en": "Riley will think about the materials she uses.",
        "ex_es": "Riley va a pensar en los materiales que usa.",
        "word_es": "recurso"
      },
      {
        "word": "profit",
        "def_en": "the money you keep after paying all your costs",
        "def_es": "El dinero que queda después de restar todos los gastos de lo que se vendió",
        "ex_en": "The ornament woman charged enough to cover her costs and make a profit.",
        "ex_es": "La mujer de los adornos cobraba lo suficiente para cubrir sus gastos y tener ganancia.",
        "word_es": "ganancia"
      },
      {
        "word": "cost",
        "def_en": "the money you spend to make something",
        "def_es": "el dinero que gastas para hacer algo",
        "ex_en": "She had to cover all her costs.",
        "ex_es": "Ella tenía que cubrir todos sus costos.",
        "word_es": "costo"
      },
      {
        "word": "pricing",
        "def_en": "figuring out the right price to charge customers",
        "def_es": "La decisión estratégica de fijar precios para comunicar calidad y tipo de cliente",
        "ex_en": "Ellis thought about pricing and why handmade things cost more.",
        "ex_es": "Ellis pensó en cómo fijar precios y por qué lo hecho a mano cuesta más.",
        "word_es": "fijar precios"
      },
      {
        "word": "quality",
        "def_en": "how good something is",
        "def_es": "Que algo esté bien hecho, con cuidado, y que dure mucho tiempo",
        "ex_en": "Her star was better quality than the toy store star.",
        "ex_es": "Su estrella era de mejor calidad que la de la juguetería.",
        "word_es": "calidad"
      },
      {
        "word": "capacity_limit",
        "def_en": "resources — materials, time, or effort — that are used or lost without producing useful output",
        "def_es": "materiales, tiempo o esfuerzo que se pierden sin servir para nada",
        "ex_en": "One mistake in carving ruined the star, so the woman had to start over, which was a waste of time and wood.",
        "ex_es": "Un error al tallar arruinaba la estrella, así que la mujer tenía que empezar de nuevo, y era un desperdicio de tiempo y madera.",
        "word_es": "límite de capacidad"
      },
      {
        "word": "display",
        "def_en": "how you arrange things to attract buyers and help them see what is for sale",
        "def_es": "Muestra organizada de objetos para que otros los vean y los aprecien",
        "ex_en": "The woman's handmade ornaments were on display at her stall at the market.",
        "ex_es": "Los adornos hechos a mano de la mujer estaban en exhibición en su puesto del mercado.",
        "word_es": "exhibición"
      },
      {
        "word": "craftsmanship",
        "def_en": "the skill of making things well by hand, learned with lots of practice",
        "def_es": "Trabajo especializado que se aprende con práctica durante años",
        "ex_en": "After twenty years of carving wood, the woman had mastered her skill.",
        "ex_es": "Después de veinte años tallando madera, la mujer dominaba su oficio.",
        "word_es": "artesanía"
      },
      {
        "word": "practice",
        "def_en": "the repeated effort of doing something until skill improves and the movements become automatic (muscle memory)",
        "def_es": "Cuando el cuerpo recuerda cómo hacer algo por haberlo practicado, sin necesidad de pensarlo",
        "ex_en": "Years of daily practice and thousands of carved stars meant her hands knew what to do without thinking about each movement.",
        "ex_es": "Años de práctica diaria y miles de estrellas talladas hicieron que sus manos supieran qué hacer sin pensar en cada movimiento.",
        "word_es": "práctica"
      }
    ],
    "title_es": "EL MERCADO DE NAVIDAD",
    "summary_es": "Mister Mason les muestra a los amigos una estrella de madera tallada a mano de un mercado navideño alemán y cuenta la historia de cómo conoció a la mujer que la hizo. A través de su demostración del tiempo, la habilidad y los materiales necesarios para tallar una sola estrella, el joven Mister Mason aprendió por qué los bienes hechos a mano cuestan más que las alternativas producidas en fábrica. Riley interioriza la lección y decide tener en cuenta su propio tiempo, habilidad y materiales al fijar precios para sus manualidades en el próximo mercado de los amigos.",
    "fl_pillar_es": "Bienes hechos a mano, valor del tiempo, fijación de precios artesanales, singularidad frente a producción en masa"
  },
  {
    "season": 2,
    "chapter": 11,
    "slug": "s2-ch11",
    "title": "EL MERCADO DE LOS MUERTOS",
    "summary": "Frances tells the friends a memory from when she was nine: her abuelita took her to a market in Mexico before Día de los Muertos. They buy orange marigolds (cempasúchil), sugar skulls with names written in icing, candles, pan de muerto and papel picado, and the whole family builds an ofrenda together, not for money or praise but for love. Back on the porch, Benny learns why remembering the people we love matters, and Riley shares her idea for a memory station at the Community Market, which she will lead. The friends learn the difference between price and true value.",
    "fl_pillar": "Value beyond price, honoring through making, intention",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch11/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch11/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch11/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch11/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch11/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch11/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch11/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch11/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "tribute",
        "def_en": "A tribute is something you make or give to honor someone you love or respect.",
        "def_es": "Un homenaje es algo que haces o das para honrar a alguien que amas o respetas.",
        "ex_en": "The family built the ofrenda as a tribute to people they loved.",
        "ex_es": "La familia armó la ofrenda como homenaje a las personas que amaba.",
        "word_es": "homenaje"
      },
      {
        "word": "intention",
        "def_en": "Intention is the meaning or purpose you put into something you make or do.",
        "def_es": "La intención es el significado o propósito que pones en algo que haces.",
        "ex_en": "The baker baked with intention, putting heart into the bread.",
        "ex_es": "El panadero horneó con intención, poniendo corazón en el pan.",
        "word_es": "intención"
      },
      {
        "word": "value",
        "def_en": "Value is how much something is worth to a person, which is not always about money.",
        "def_es": "El valor es cuánto vale algo para una persona, y no siempre se trata de dinero.",
        "ex_en": "The marigolds had value to Abuelita because they guided the spirits home.",
        "ex_es": "Las flores tenían valor para la abuelita porque guiaban a los espíritus a casa.",
        "word_es": "valor"
      },
      {
        "word": "priceless",
        "def_en": "Priceless means something is so special that no amount of money could pay for it.",
        "def_es": "Invaluable quiere decir que algo es tan especial que ninguna cantidad de dinero podría pagarlo.",
        "ex_en": "The memory of Abuelo was priceless to Frances, so she chose his favorite colors.",
        "ex_es": "El recuerdo de Abuelo era invaluable para Frances, así que eligió sus colores favoritos.",
        "word_es": "invaluable"
      },
      {
        "word": "respect",
        "def_en": "treating someone or something as important and special",
        "def_es": "tratar a alguien o algo como importante y especial",
        "ex_en": "Young Frances touched the sugar skull very gently, with quiet respect.",
        "ex_es": "Frances de niña tocó la calavera de azúcar con mucho cuidado y con respeto.",
        "word_es": "respeto"
      },
      {
        "word": "care",
        "def_en": "paying close attention so that something is done gently and well",
        "def_es": "poner mucha atención para que algo se haga con delicadeza y bien hecho",
        "ex_en": "The family placed the flowers, candles, photos, sugar skulls and bread on the ofrenda with great care.",
        "ex_es": "La familia puso con mucho cuidado las flores, las velas, las fotos, las calaveras y el pan en la ofrenda.",
        "word_es": "cuidado"
      },
      {
        "word": "share",
        "def_en": "to give part of what you have, or what you feel, to other people",
        "def_es": "dar a otras personas parte de lo que tienes o de lo que sientes",
        "ex_en": "Frances said the market is not just about trading things for money; it is about sharing what matters most to your heart.",
        "ex_es": "Frances dijo que el mercado no se trata solo de cambiar cosas por dinero, sino de compartir lo que más le importa a tu corazón.",
        "word_es": "compartir"
      }
    ],
    "title_es": "EL MERCADO DE LOS MUERTOS",
    "summary_es": "Frances les cuenta a los amigos un recuerdo de cuando tenía nueve años: su abuelita la llevó a un mercado en México antes del Día de los Muertos. Compran cempasúchil, calaveras de azúcar con nombres escritos con betún, velas, pan de muerto y papel picado, y toda la familia arma la ofrenda junta, no por dinero ni por elogios, sino por amor. De vuelta en el porche, Benny aprende por qué importa recordar a las personas que queremos, y Riley comparte su idea de una estación de los recuerdos para el Mercado Comunitario, que ella va a dirigir. Los amigos aprenden la diferencia entre el precio y el valor verdadero.",
    "fl_pillar_es": "Valor más allá del precio, honrar haciendo con las manos, intención"
  },
  {
    "season": 2,
    "chapter": 12,
    "slug": "s2-ch12",
    "title": "LA TAMALADA & THE COMMUNITY MARKET",
    "summary": "On the morning of the Community Market, Frances gathers the friends in her kitchen for a tamalada -- a traditional tamale-making session that teaches them the power of collaboration through division of labor. After initial struggles, they find their rhythm and produce dozens of perfect tamales. They then set up the market in the park with distinct areas reflecting everything they have learned throughout the season: a swap zone, an auction corner, a craft station, and a memory corner. Each friend leads the area matching their strengths. Mister Mason arrives and acknowledges their growth. When a young child asks to be taught, the friends realize they have evolved from learners into teachers.",
    "fl_pillar": "Collaboration, community, division of labor, applying all season lessons",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch12/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch12/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch12/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch12/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch12/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch12/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s2/ch12/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s2/ch12/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "value",
        "def_en": "the worth something has, not just in money but in how much it helps or matters to people",
        "def_es": "lo que algo vale, no solo en dinero sino en cuánto ayuda a las personas",
        "ex_en": "People went home happy with treasures and memories that had value to them.",
        "ex_es": "La gente se fue a casa contenta con tesoros y recuerdos que tenían valor para ellos.",
        "word_es": "valor"
      },
      {
        "word": "free",
        "def_en": "no money required; given freely or available without payment",
        "def_es": "que no pide dinero; se da o se ofrece sin pagar",
        "ex_en": "Neighbors brought something special to share for free, in the spirit of giving and cooperation.",
        "ex_es": "Los vecinos llevaron algo especial para compartir gratis, con espíritu de generosidad y cooperación.",
        "word_es": "gratis"
      },
      {
        "word": "resource",
        "def_en": "the supplies, materials, and ingredients needed to make something",
        "def_es": "Todo lo que se necesita para hacer algo: materiales, dinero, tiempo, esfuerzo",
        "ex_en": "The masa, filling, and corn husks were the resources the friends used to make tamales.",
        "ex_es": "La masa, el relleno y las hojas de maíz eran los recursos para hacer los tamales.",
        "word_es": "recurso"
      },
      {
        "word": "cost",
        "def_en": "the money spent on everything needed to produce a good or service",
        "def_es": "el dinero que se gasta en todo lo necesario para hacer un producto",
        "ex_en": "Frances and the friends shared the tamales without any cost to the neighbors who came.",
        "ex_es": "Frances y los amigos compartieron los tamales sin ningún costo para los vecinos que vinieron.",
        "word_es": "costo"
      },
      {
        "word": "planning",
        "def_en": "thinking ahead and organizing your steps so everything goes smoothly",
        "def_es": "Pensar y organizar lo que se va a hacer antes de hacerlo",
        "ex_en": "Layla smiled at the park, where the market had been set up with careful planning.",
        "ex_es": "Layla sonrió en el parque, donde el mercado se había preparado con una planificación cuidadosa.",
        "word_es": "planificación"
      },
      {
        "word": "quality",
        "def_en": "how good something is",
        "def_es": "Que algo esté bien hecho, con cuidado, y que dure mucho tiempo",
        "ex_en": "Layla checked the quality of each tamale.",
        "ex_es": "Layla revisó la calidad de cada tamal.",
        "word_es": "calidad"
      },
      {
        "word": "division_of_labor",
        "def_en": "splitting up work so everyone does what they are best at",
        "def_es": "Organización en la que cada persona se dedica a la tarea que mejor sabe hacer, logrando más con menos esfuerzo",
        "ex_en": "Each friend had a different task, so the division of labor made the work easier.",
        "ex_es": "Cada amigo tenía una tarea distinta, y la división del trabajo hizo todo más fácil.",
        "word_es": "división del trabajo"
      },
      {
        "word": "capacity_limit",
        "def_en": "resources — materials, time, or effort — that are used or lost without producing useful output",
        "def_es": "materiales, tiempo o esfuerzo que se pierden sin servir para nada",
        "ex_en": "Layla caught problems quickly before they became bigger issues that would waste ingredients.",
        "ex_es": "Layla detectaba los problemas pronto, para evitar el desperdicio de ingredientes.",
        "word_es": "límite de capacidad"
      },
      {
        "word": "display",
        "def_en": "how you arrange things to attract buyers and help them see what is for sale",
        "def_es": "Muestra organizada de objetos para que otros los vean y los aprecien",
        "ex_en": "Riley's paper marigolds were displayed attractively at her craft station.",
        "ex_es": "Las caléndulas de papel de Riley estaban en exhibición en su estación de manualidades.",
        "word_es": "exhibición"
      },
      {
        "word": "trade_barter",
        "def_en": "swapping one thing for another without using money",
        "def_es": "Cambiar una cosa por otra (trueque, sin dinero) o entregar un producto a cambio de dinero (transacción)",
        "ex_en": "The market had a swap area for trading things.",
        "ex_es": "En el mercado había una zona de intercambio.",
        "word_es": "trueque"
      },
      {
        "word": "craftsmanship",
        "def_en": "the skill of making things well by hand, learned with lots of practice",
        "def_es": "Trabajo especializado que se aprende con práctica durante años",
        "ex_en": "Riley's masa got smooth every time, a skill she learned by working with her hands.",
        "ex_es": "La masa de Riley quedaba suave siempre, un oficio que fue aprendiendo con las manos.",
        "word_es": "artesanía"
      },
      {
        "word": "practice",
        "def_en": "doing something repeatedly until you improve and your body learns to do it naturally",
        "def_es": "Cuando el cuerpo recuerda cómo hacer algo por haberlo practicado, sin necesidad de pensarlo",
        "ex_en": "Benny wrapped too loose at first, but with practice his wraps got tight without gaps.",
        "ex_es": "Al principio Benny envolvía muy flojo, pero con práctica sus tamales quedaron firmes, sin huecos.",
        "word_es": "práctica"
      }
    ],
    "title_es": "LA TAMALADA Y EL MERCADO COMUNITARIO",
    "summary_es": "En la mañana del Mercado Comunitario, Frances reúne a los amigos en su cocina para una tamalada, una sesión tradicional de preparación de tamales que les enseña el poder de la colaboración a través de la división del trabajo. Después de dificultades iniciales, encuentran su ritmo y producen docenas de tamales perfectos. Luego montan el mercado en el parque con áreas distintas que reflejan todo lo que han aprendido durante la temporada: una zona de intercambio, un rincón de subastas, una estación de manualidades y un rincón de la memoria. Cada amigo lidera el área que corresponde a sus fortalezas. Mister Mason llega y reconoce su crecimiento. Cuando un niño pequeño pide que le enseñen, los amigos se dan cuenta de que han pasado de ser aprendices a ser maestros.",
    "fl_pillar_es": "Colaboración, comunidad, división del trabajo, aplicación de todas las lecciones de la temporada"
  },
  {
    "season": 3,
    "chapter": 1,
    "slug": "s3-ch01",
    "title": "THE INVITATION ARRIVES",
    "summary": "The four friends discover three mysterious sealed envelopes waiting for them inside their fort. Each invitation summons them to learn a different craft from a different master at a different location. Using Ellis's map and the magically glowing wax seals, they identify the three destinations. They plan their first journey and encourage each other to face the unknown, leaving with excitement for the adventures ahead.",
    "fl_pillar": "Craftsmanship, learning skills, the value of learning from masters",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch1/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch1/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch1/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch1/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch1/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch1/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch1/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch1/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "value",
        "def_en": "the usefulness or worth of something to people",
        "def_es": "lo que algo vale, no solo en dinero sino en cuánto ayuda a las personas",
        "ex_en": "Benny said the invitations were not just paper and wax, they had real value as chances to learn.",
        "ex_es": "Benny dijo que las invitaciones no eran solo papel y cera, tenían un gran valor como oportunidades para aprender.",
        "word_es": "valor"
      },
      {
        "word": "opportunity_cost",
        "def_en": "a chance to learn or do something new",
        "def_es": "Lo que pierdes por elegir una cosa en vez de otra; el precio de usar tu tiempo en algo",
        "ex_en": "Sleeping in was the opportunity cost of Benny learning woodworking at sunrise.",
        "ex_es": "Dormir hasta tarde era el costo de oportunidad de que Benny aprendiera carpintería al amanecer.",
        "word_es": "costo de oportunidad"
      },
      {
        "word": "craftsmanship",
        "def_en": "the skill and art of making things well by hand",
        "def_es": "Trabajo especializado que se aprende con práctica durante años",
        "ex_en": "Riley worried about woodworking, but Layla said nobody is perfect at a new skill at first.",
        "ex_es": "Riley se preocupó por la carpintería, pero Layla dijo que nadie domina un oficio nuevo al principio.",
        "word_es": "artesanía"
      },
      {
        "word": "invitation",
        "def_en": "a request for someone to come to an event",
        "def_es": "una petición para que alguien venga a un evento",
        "ex_en": "Layla read the invitation to her friends.",
        "ex_es": "Layla leyó la invitación a sus amigos.",
        "word_es": "invitación"
      },
      {
        "word": "wax_seal",
        "def_en": "a mark pressed into wax to close a letter",
        "def_es": "una marca apretada en la cera para cerrar una carta",
        "ex_en": "Layla broke the green wax seal.",
        "ex_es": "Layla rompió el sello de cera verde.",
        "word_es": "sello de cera"
      }
    ],
    "title_es": "LA INVITACIÓN LLEGA",
    "summary_es": "Los cuatro amigos descubren tres sobres misteriosos sellados esperándolos dentro de su fuerte. Cada invitación los convoca a aprender un oficio diferente con un maestro diferente en un lugar diferente. Usando el mapa de Ellis y los sellos de cera que brillan mágicamente, identifican los tres destinos. Planifican su primer viaje y se animan mutuamente a enfrentar lo desconocido, partiendo con entusiasmo por las aventuras que les esperan.",
    "fl_pillar_es": "Artesanía, aprendizaje de habilidades, el valor de aprender de los maestros"
  },
  {
    "season": 3,
    "chapter": 2,
    "slug": "s3-ch02",
    "title": "JOURNEY TO THE WOODWORKER'S GROVE",
    "summary": "The friends wake before dawn and journey through the woods to Willow Grove for their first craft lesson. They find the rustic open-air workshop of Master Thomas, who welcomes them with warmth and begins teaching woodworking fundamentals. Rather than jumping straight into building, he teaches them to respect the material: where wood comes from, how to read its grain, how to organize tools, and why patience is essential. Each friend selects a piece of wood to study at home before next week's hands-on session.",
    "fl_pillar": "Finding teachers, respect for craft, understanding tradition and stewardship of materials",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch2/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch2/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch2/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch2/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch2/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch2/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch2/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch2/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "craftsmanship",
        "def_en": "skill in making things well by hand",
        "def_es": "Trabajo especializado que se aprende con práctica durante años",
        "ex_en": "The woodworker's hands moved with practiced skill, and the friends waited quietly instead of interrupting his work.",
        "ex_es": "Las manos del carpintero se movían con el oficio de muchos años, y los amigos esperaron callados para no interrumpir.",
        "word_es": "artesanía"
      },
      {
        "word": "patience",
        "def_en": "able to wait calmly without rushing",
        "def_es": "que puede esperar con calma, sin apurarse",
        "ex_en": "Master Thomas said woodworking needs patience.",
        "ex_es": "Master Thomas dijo que la carpintería pide paciencia.",
        "word_es": "paciencia"
      },
      {
        "word": "grain",
        "def_en": "the lines in wood showing how the tree grew",
        "def_es": "las líneas de la madera que muestran cómo creció el árbol",
        "ex_en": "Riley picked oak with interesting grain for her piece of wood.",
        "ex_es": "Riley eligió roble con una veta interesante para su pedazo de madera.",
        "word_es": "veta"
      },
      {
        "word": "care",
        "def_en": "treating something with care because it matters",
        "def_es": "tratar algo con cuidado porque es importante",
        "ex_en": "Master Thomas repeated each name with care.",
        "ex_es": "Master Thomas repitió cada nombre con cuidado.",
        "word_es": "cuidado"
      },
      {
        "word": "tradition",
        "def_en": "a way of doing things passed down over time",
        "def_es": "una manera de hacer las cosas que pasa de una generación a otra",
        "ex_en": "The friends learned that the grove kept a woodworking tradition for three hundred years.",
        "ex_es": "Los amigos supieron que la arboleda mantenía una tradición de carpintería desde hace trescientos años.",
        "word_es": "tradición"
      }
    ],
    "title_es": "VIAJE AL BOSQUE DEL CARPINTERO",
    "summary_es": "Los amigos se despiertan antes del amanecer y viajan por el bosque hasta la Arboleda de los Sauces para su primera lección de oficio. Encuentran el rústico taller al aire libre de Master Thomas, quien los recibe con calidez y comienza a enseñar los fundamentos de la carpintería. En lugar de lanzarse directamente a construir, les enseña a respetar el material: de dónde viene la madera, cómo leer su veta, cómo organizar las herramientas y por qué la paciencia es esencial. Cada amigo selecciona una pieza de madera para estudiar en casa antes de la sesión práctica de la próxima semana.",
    "fl_pillar_es": "Encontrar maestros, respeto por el oficio, comprensión de la tradición y cuidado de los materiales"
  },
  {
    "season": 3,
    "chapter": 3,
    "slug": "s3-ch03",
    "title": "THE SAWDUST CHALLENGE",
    "summary": "The friends return to Willow Grove for their first hands-on building session. Master Thomas guides them through measuring, cutting, sanding, and gluing to build simple wooden boxes. Every friend makes mistakes -- crooked cuts, oversanded pieces, gaps in joints, glue everywhere -- and Master Thomas calmly turns each error into a lesson. They finish their imperfect first boxes and learn that mistakes are essential teachers, that quality requires patience, and that keeping their first attempt is important because it marks the beginning of their journey as makers.",
    "fl_pillar": "Practice makes better, learning from mistakes, quality takes time",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch3/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch3/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch3/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch3/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch3/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch3/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch3/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch3/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "quality",
        "def_en": "how well something is made",
        "def_es": "Que algo esté bien hecho, con cuidado, y que dure mucho tiempo",
        "ex_en": "Master Thomas said quality takes time.",
        "ex_es": "Master Thomas dijo que la calidad necesita tiempo.",
        "word_es": "calidad"
      },
      {
        "word": "craftsmanship",
        "def_en": "the way you do something with skill",
        "def_es": "Trabajo especializado que se aprende con práctica durante años",
        "ex_en": "While the glue dried, each friend cut several practice pieces, and their technique improved with every cut.",
        "ex_es": "Mientras el pegamento secaba, cada amigo cortó varias piezas, y su oficio mejoraba con cada corte.",
        "word_es": "artesanía"
      },
      {
        "word": "practice",
        "def_en": "doing something over and over to get better",
        "def_es": "Cuando el cuerpo recuerda cómo hacer algo por haberlo practicado, sin necesidad de pensarlo",
        "ex_en": "With practice, each cut the friends made got better.",
        "ex_es": "Con práctica, los cortes de los amigos salían mejor.",
        "word_es": "práctica"
      },
      {
        "word": "patience",
        "def_en": "staying calm and taking time to do things right",
        "def_es": "mantener la calma y tomarte el tiempo para hacer las cosas bien",
        "ex_en": "Master Thomas said Riley had patience with the saw.",
        "ex_es": "Master Thomas dijo que Riley tenía paciencia con la sierra.",
        "word_es": "paciencia"
      },
      {
        "word": "grain",
        "def_en": "the lines in wood that show how the tree grew",
        "def_es": "las líneas de la madera que muestran cómo creció el árbol",
        "ex_en": "Master Thomas told them to always sand with the grain.",
        "ex_es": "Master Thomas les dijo que siempre lijen en la dirección de la veta.",
        "word_es": "veta"
      }
    ],
    "title_es": "EL DESAFÍO DEL ASERRÍN",
    "summary_es": "Los amigos regresan a la Arboleda de los Sauces para su primera sesión práctica de construcción. Master Thomas los guía a través de medir, cortar, lijar y pegar para construir cajas de madera simples. Cada amigo comete errores: cortes torcidos, piezas lijadas de más, separaciones en las juntas, pegamento por todas partes, y Master Thomas transforma con calma cada error en una lección. Terminan sus primeras cajas imperfectas y aprenden que los errores son maestros esenciales, que la calidad requiere paciencia, y que guardar su primer intento es importante porque marca el inicio de su camino como creadores.",
    "fl_pillar_es": "La práctica mejora, aprender de los errores, la calidad toma tiempo"
  },
  {
    "season": 3,
    "chapter": 4,
    "slug": "s3-ch04",
    "title": "BUILDING BOXES",
    "summary": "The friends return for their third and final week of woodworking at Willow Grove. They build new boxes and discover their skills have noticeably improved through practice. Master Thomas introduces a new technique -- carving decorative designs -- and each friend makes a different choice about whether and what to carve. They learn to finish wood with oil, compare their first-week boxes to their new ones, and see tangible proof of their growth. Master Thomas bids them farewell as they prepare for pottery the following week, assuring them that skills once learned stay forever.",
    "fl_pillar": "Practice makes better, skill development through repetition, quality improvement over time",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch4/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch4/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch4/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch4/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch4/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch4/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch4/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch4/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "craftsmanship",
        "def_en": "the way you do something with skill",
        "def_es": "Trabajo especializado que se aprende con práctica durante años",
        "ex_en": "Riley's carved flower slowly appeared in the smooth wood, a sign of growing craftsmanship.",
        "ex_es": "La flor tallada de Riley apareció poco a poco en la madera suave, una muestra de su artesanía.",
        "word_es": "artesanía"
      },
      {
        "word": "practice",
        "def_en": "doing something over and over to get better",
        "def_es": "Cuando el cuerpo recuerda cómo hacer algo por haberlo practicado, sin necesidad de pensarlo",
        "ex_en": "Practice helped Layla make straighter pencil marks.",
        "ex_es": "La práctica ayudó a Layla a hacer marcas más derechas.",
        "word_es": "práctica"
      },
      {
        "word": "pattern",
        "def_en": "a design that repeats or looks nice",
        "def_es": "un dibujo que se repite o que se ve bonito",
        "ex_en": "Ellis carved a star pattern on his box.",
        "ex_es": "Ellis talló un patrón de estrella en su caja.",
        "word_es": "patrón"
      },
      {
        "word": "foundation",
        "def_en": "basic and important skills you need first",
        "def_es": "las habilidades básicas e importantes que necesitas primero",
        "ex_en": "Master Thomas said Layla showed wisdom by building a foundation before adding extras.",
        "ex_es": "Master Thomas dijo que Layla mostró sabiduría al construir primero los fundamentos antes de agregar extras.",
        "word_es": "fundamentos"
      }
    ],
    "title_es": "CONSTRUYENDO CAJAS",
    "summary_es": "Los amigos regresan para su tercera y última semana de carpintería en la Arboleda de los Sauces. Construyen cajas nuevas y descubren que sus habilidades han mejorado notablemente con la práctica. Master Thomas introduce una técnica nueva: el tallado de diseños decorativos, y cada amigo toma una decisión diferente sobre si tallar y qué tallar. Aprenden a acabar la madera con aceite, comparan sus cajas de la primera semana con las nuevas y ven pruebas tangibles de su crecimiento. Master Thomas se despide de ellos mientras se preparan para la alfarería la semana siguiente, asegurándoles que las habilidades aprendidas permanecen para siempre.",
    "fl_pillar_es": "La práctica mejora, desarrollo de habilidades a través de la repetición, mejora de calidad con el tiempo"
  },
  {
    "season": 3,
    "chapter": 5,
    "slug": "s3-ch05",
    "title": "THE POTTER'S VALLEY",
    "summary": "The four friends arrive at Potter's Valley for their first pottery lesson with Celeste, the Potter. She teaches them the core steps of working with clay — wedging, centering, and throwing — emphasizing that patience is the most essential tool. Each friend struggles in a different way, but after sustained effort, they produce their first handmade bowls. They leave understanding that pottery rewards patience and feeling rather than force and speed.",
    "fl_pillar": "Patience and practice — good work cannot be rushed",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch5/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch5/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch5/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch5/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch5/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch5/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch5/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch5/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "quality_control",
        "def_en": "checking to make sure something is made well",
        "def_es": "Revisar que algo esté bien hecho y mantener la misma calidad cada vez",
        "ex_en": "Celeste said the clay becomes smooth and consistent when it is wedged well.",
        "ex_es": "Celeste dijo que la arcilla bien amasada queda lisa y con consistencia.",
        "word_es": "control de calidad"
      },
      {
        "word": "patience",
        "def_en": "staying calm and taking time to do things right",
        "def_es": "mantener la calma y tomarte el tiempo para hacer las cosas bien",
        "ex_en": "Celeste said patience is very important with clay.",
        "ex_es": "Celeste dijo que la paciencia es muy importante con la arcilla.",
        "word_es": "paciencia"
      },
      {
        "word": "gentle",
        "def_en": "soft and careful, not rough or forceful",
        "def_es": "suave y con cuidado, sin fuerza ni brusquedad",
        "ex_en": "Celeste said clay is soft, so you must be gentle with it.",
        "ex_es": "Celeste dijo que la arcilla es blanda, así que hay que ser suave con ella.",
        "word_es": "suave"
      },
      {
        "word": "centering",
        "def_en": "making something balanced in the middle",
        "def_es": "dejar algo bien centrado en el medio",
        "ex_en": "Layla tried centering her clay on the wheel.",
        "ex_es": "Layla intentó dejar su arcilla centrada en el torno.",
        "word_es": "centrado"
      },
      {
        "word": "wedging",
        "def_en": "pushing and folding clay to remove air bubbles",
        "def_es": "apretar y doblar el barro para sacarle las burbujas de aire",
        "ex_en": "Riley's arms got tired from wedging the clay on the table.",
        "ex_es": "A Riley se le cansaron los brazos con el amasado de la arcilla.",
        "word_es": "amasado"
      }
    ],
    "title_es": "EL VALLE DEL ALFARERO",
    "summary_es": "Los cuatro amigos llegan al Valle del Alfarero para su primera lección de alfarería con Celeste, la Alfarera. Ella les enseña los pasos fundamentales de trabajar con arcilla: amasar, centrar y tornear, enfatizando que la paciencia es la herramienta más esencial. Cada amigo tiene dificultades de manera diferente, pero después de un esfuerzo sostenido, producen sus primeros tazones hechos a mano. Se van entendiendo que la alfarería recompensa la paciencia y el sentimiento en lugar de la fuerza y la velocidad.",
    "fl_pillar_es": "Paciencia y práctica: el buen trabajo no se puede apurar"
  },
  {
    "season": 3,
    "chapter": 6,
    "slug": "s3-ch06",
    "title": "THROWING AND TURNING",
    "summary": "The friends return to Potter's Valley for their second lesson and are tasked with making five bowls each. Through focused repetition, each friend discovers that their skills improve visibly from bowl to bowl. Celeste introduces the idea that matching, consistent work has greater value than mismatched pieces, connecting the craft to broader lessons about how practice builds skill, and skill creates quality and value.",
    "fl_pillar": "Practice builds skill; consistency creates value",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch6/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch6/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch6/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch6/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch6/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch6/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch6/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch6/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "quality",
        "def_en": "how well something is made",
        "def_es": "Que algo esté bien hecho, con cuidado, y que dure mucho tiempo",
        "ex_en": "Everyone pointed to the even bowl as the better quality.",
        "ex_es": "Todos señalaron el tazón parejo, el de mejor calidad.",
        "word_es": "calidad"
      },
      {
        "word": "quality_control",
        "def_en": "the same every time you do it",
        "def_es": "Revisar que algo esté bien hecho y mantener la misma calidad cada vez",
        "ex_en": "Celeste said Riley was more consistent now.",
        "ex_es": "Celeste dijo que Riley tenía más consistencia ahora.",
        "word_es": "control de calidad"
      },
      {
        "word": "practice",
        "def_en": "doing something over and over to get better",
        "def_es": "Cuando el cuerpo recuerda cómo hacer algo por haberlo practicado, sin necesidad de pensarlo",
        "ex_en": "Benny's hands remembered because of all his practice.",
        "ex_es": "Las manos de Benny recordaban gracias a la práctica.",
        "word_es": "práctica"
      }
    ],
    "title_es": "TORNEADO Y MOLDEADO",
    "summary_es": "Los amigos regresan al Valle del Alfarero para su segunda lección y se les encarga hacer cinco tazones cada uno. A través de la repetición enfocada, cada amigo descubre que sus habilidades mejoran visiblemente de tazón a tazón. Celeste introduce la idea de que un trabajo parejo y consistente tiene mayor valor que piezas disparejas, conectando el oficio con lecciones más amplias sobre cómo la práctica desarrolla habilidad, y la habilidad crea calidad y valor.",
    "fl_pillar_es": "La práctica desarrolla habilidad; la consistencia crea valor"
  },
  {
    "season": 3,
    "chapter": 7,
    "slug": "s3-ch07",
    "title": "THE KILN'S SECRET",
    "summary": "On their third Saturday, the friends learn about the kiln — the transformative step that turns fragile dried clay into permanent pottery. Celeste explains the lengthy firing process, the risks of breakage, the science of shrinkage, and the art of glazing. The friends discover that transformation requires time, heat, and patience, and that the risk of loss is factored into the price of finished work. They leave with their bowls inside the kiln, understanding that the value of crafted goods reflects the full journey of making them.",
    "fl_pillar": "Transformation adds value; pricing reflects hidden costs (breakage, time, risk)",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch7/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch7/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch7/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch7/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch7/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch7/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch7/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch7/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "value",
        "def_en": "how much something is worth after time and work",
        "def_es": "lo que algo vale, no solo en dinero sino en cuánto ayuda a las personas",
        "ex_en": "Celeste said time, heat, and patience create lasting value, and skills work the same way.",
        "ex_es": "Celeste dijo que el tiempo, el calor y la paciencia crean valor duradero, y las habilidades funcionan igual.",
        "word_es": "valor"
      },
      {
        "word": "sunk_cost",
        "def_en": "time or money already invested that cannot be recovered",
        "def_es": "Dinero o tiempo que ya se gastó y no se puede recuperar",
        "ex_en": "The money already spent on the failed product was a sunk cost.",
        "ex_es": "Eso se llama costo hundido, y seguir pagándolo no lo convierte en inversión.",
        "word_es": "costo hundido"
      },
      {
        "word": "risk",
        "def_en": "the chance that something might not work",
        "def_es": "La posibilidad de que algo salga mal o de perder dinero, como cuando casi todos los ingresos dependen de muy pocos clientes (concentración de clientes)",
        "ex_en": "Firing is risky, because one air bubble can make a bowl explode inside the kiln.",
        "ex_es": "Hornear tiene su riesgo, porque una sola burbuja de aire puede hacer explotar un tazón dentro del horno.",
        "word_es": "riesgo"
      },
      {
        "word": "quality_control",
        "def_en": "keeping records to make sure things are done right",
        "def_es": "Revisar que algo esté bien hecho y mantener la misma calidad cada vez",
        "ex_en": "Celeste keeps a notebook of temperature and timing, which she calls quality control documentation.",
        "ex_es": "Celeste llena un cuaderno de control de calidad con la temperatura y el tiempo de cada horneada.",
        "word_es": "control de calidad"
      },
      {
        "word": "patience",
        "def_en": "being able to wait calmly",
        "def_es": "poder esperar con calma",
        "ex_en": "Benny said almost two days, and the Potter said pottery needs patience at every step.",
        "ex_es": "Benny dijo casi dos días, y Celeste dijo que la alfarería pide paciencia en cada paso.",
        "word_es": "paciencia"
      },
      {
        "word": "care",
        "def_en": "treating something carefully",
        "def_es": "tratar algo con cuidado",
        "ex_en": "Celeste loads each pot with care so none touch.",
        "ex_es": "Celeste carga cada pieza con cuidado para que no se toquen.",
        "word_es": "cuidado"
      },
      {
        "word": "kiln",
        "def_en": "a hot oven for pottery",
        "def_es": "un horno muy caliente para la cerámica",
        "ex_en": "Celeste stood next to the big brick kiln.",
        "ex_es": "Celeste estaba junto al horno de ladrillos, que brillaba anaranjado.",
        "word_es": "horno"
      },
      {
        "word": "sintering",
        "def_en": "when clay particles bond together permanently through heat",
        "def_es": "cuando el calor une el barro para siempre y lo endurece",
        "ex_en": "Riley's bowl shrinks about thirty percent in the fire, and sintering makes the clay particles bond for good.",
        "ex_es": "El tazón de Riley se encoge como un treinta por ciento en el fuego, y la sinterización une las partículas para siempre.",
        "word_es": "sinterización"
      },
      {
        "word": "transformation",
        "def_en": "when something changes",
        "def_es": "cuando algo cambia",
        "ex_en": "Celeste said transformation takes time, heat, and patience working together.",
        "ex_es": "Celeste dijo que la transformación necesita tiempo, calor y paciencia.",
        "word_es": "transformación"
      }
    ],
    "title_es": "EL SECRETO DEL HORNO",
    "summary_es": "En su tercer sábado, los amigos aprenden sobre el horno, el paso transformador que convierte la arcilla seca y frágil en cerámica permanente. Celeste explica el largo proceso de cocción, los riesgos de rotura, la ciencia de la contracción y el arte del esmaltado. Los amigos descubren que la transformación requiere tiempo, calor y paciencia, y que el riesgo de pérdida está incluido en el precio del trabajo terminado. Se van con sus tazones dentro del horno, entendiendo que el valor de los bienes artesanales refleja todo el recorrido de su creación.",
    "fl_pillar_es": "La transformación agrega valor; los precios reflejan costos ocultos (roturas, tiempo, riesgo)"
  },
  {
    "season": 3,
    "chapter": 8,
    "slug": "s3-ch08",
    "title": "THE INVENTOR'S TOWER",
    "summary": "Two weeks after their pottery lessons, the friends follow their third invitation to the Inventor's Tower. Maestro Gearsmith introduces them to the invention process: identifying real problems, imagining solutions, drawing blueprints, building prototypes from simple materials, and improving designs through testing. Each friend works through one personal problem and discovers that creativity combined with systematic testing produces useful things. They leave understanding that good ideas, rigorously tested, create genuine value.",
    "fl_pillar": "Design thinking — identifying problems, prototyping solutions, iterating to create value",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch8/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch8/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch8/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch8/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch8/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch8/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch8/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch8/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "value",
        "def_en": "making something useful that helps people",
        "def_es": "lo que algo vale, no solo en dinero sino en cuánto ayuda a las personas",
        "ex_en": "The Gearsmith said design thinking creates real value for people who need solutions.",
        "ex_es": "El Maestro dijo que el pensamiento de diseño crea valor real para las personas que necesitan soluciones.",
        "word_es": "valor"
      },
      {
        "word": "prototype",
        "def_en": "creating new ways to solve problems that create value",
        "def_es": "Crear algo nuevo: la primera versión que se construye para probarla (prototipo) y el ciclo de probar, fallar y ajustar (iteración)",
        "ex_en": "Riley's paper cover failed the water test, so she suggested waxed paper or plastic, a new iteration of her prototype.",
        "ex_es": "La cubierta de papel de Riley falló con el agua, así que propuso papel encerado o plástico, una nueva iteración de su prototipo.",
        "word_es": "prototipo"
      },
      {
        "word": "repair",
        "def_en": "something that needs fixing",
        "def_es": "algo que necesita arreglo",
        "ex_en": "Ellis folded the edges to repair his bent tray.",
        "ex_es": "Ellis dobló los bordes para reparar su bandeja doblada.",
        "word_es": "reparar"
      }
    ],
    "title_es": "LA TORRE DEL INVENTOR",
    "summary_es": "Dos semanas después de sus lecciones de alfarería, los amigos siguen su tercera invitación hasta la Torre del Inventor. El Maestro Gearsmith les presenta el proceso de invención: identificar problemas reales, imaginar soluciones, dibujar planos, construir prototipos con materiales simples y mejorar los diseños a través de pruebas. Cada amigo trabaja en un problema personal y descubre que la creatividad combinada con las pruebas sistemáticas produce cosas útiles. Se van entendiendo que las buenas ideas, probadas rigurosamente, crean valor genuino.",
    "fl_pillar_es": "Pensamiento de diseño: identificar problemas, crear prototipos de soluciones, iterar para crear valor"
  },
  {
    "season": 3,
    "chapter": 9,
    "slug": "s3-ch09",
    "title": "BLUEPRINT DREAMS",
    "summary": "The four friends return to the Gearsmith's Tower for their second lesson. The Gearsmith introduces them to professional drafting tools and the discipline of blueprint creation. Each friend learns a specific measurement skill -- ruler use, straight-line drawing, scale representation, and angle measurement -- then applies those skills to draft improved blueprints of their original inventions from the previous session. The chapter closes with the Gearsmith connecting planning to both financial savings and turning dreams into reality.",
    "fl_pillar": "Planning before building, measuring to avoid waste",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch9/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch9/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch9/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch9/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch9/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch9/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch9/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch9/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "cost",
        "def_en": "lowering expenses by cutting waste",
        "def_es": "bajar los gastos quitando lo que se desperdicia",
        "ex_en": "Planning cuts costs, the Gearsmith said, because materials are expensive but paper and thinking are cheap.",
        "ex_es": "El Maestro dijo que planear baja los costos, porque los materiales son caros y pensar es barato.",
        "word_es": "costo"
      },
      {
        "word": "planning",
        "def_en": "thinking ahead before you do something",
        "def_es": "Pensar y organizar lo que se va a hacer antes de hacerlo",
        "ex_en": "Planning helped Layla know what to build.",
        "ex_es": "Planificar ayudó a Layla a saber qué construir.",
        "word_es": "planificación"
      },
      {
        "word": "blueprint",
        "def_en": "a plan that shows how to build something",
        "def_es": "Dibujos que muestran cómo construir algo, con flechas y medidas precisas",
        "ex_en": "The friends looked at the blueprint of the water wheel.",
        "ex_es": "Los amigos miraron el plano de la rueda de agua.",
        "word_es": "plano"
      }
    ],
    "title_es": "SUEÑOS DE PLANOS",
    "summary_es": "Los cuatro amigos regresan a la Torre del Gearsmith para su segunda lección. El Gearsmith les presenta las herramientas profesionales de dibujo técnico y la disciplina de la creación de planos. Cada amigo aprende una habilidad específica de medición: uso de la regla, dibujo de líneas rectas, representación a escala y medición de ángulos, y luego aplica esas habilidades para elaborar planos mejorados de sus inventos originales de la sesión anterior. El capítulo cierra con el Gearsmith conectando la planificación con el ahorro financiero y la conversión de sueños en realidad.",
    "fl_pillar_es": "Planificar antes de construir, medir para evitar el desperdicio"
  },
  {
    "season": 3,
    "chapter": 10,
    "slug": "s3-ch10",
    "title": "THE MAKER'S MARKET RESEARCH",
    "summary": "Layla announces an upcoming Maker's Market and the friends eagerly plan what to make. Ellis raises the crucial question of whether anyone would actually want their products. Layla proposes surveying the neighborhood to find out. The friends design a survey, canvass ten families, then analyze the data back at the fort. They discover clear demand patterns -- key hooks are most wanted, followed by plant holders -- and realize that research before production prevents wasted effort and materials.",
    "fl_pillar": "Market research, customer needs, demand",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch10/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch10/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch10/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch10/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch10/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch10/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch10/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch10/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "planning",
        "def_en": "deciding what and how much to make based on demand",
        "def_es": "Pensar y organizar lo que se va a hacer antes de hacerlo",
        "ex_en": "The friends used production planning to decide what to make, starting with key hooks because five people wanted them.",
        "ex_es": "Los amigos usaron la planificación de la producción para decidir qué hacer, empezando por los ganchos que cinco personas pidieron.",
        "word_es": "planificación"
      },
      {
        "word": "market_research",
        "def_en": "finding out what people want before making something",
        "def_es": "Herramienta de investigación con preguntas organizadas para saber qué quiere la gente antes de producir",
        "ex_en": "Riley made a survey with questions for the neighbors.",
        "ex_es": "Riley hizo una encuesta con preguntas para los vecinos.",
        "word_es": "investigación de mercado"
      },
      {
        "word": "customer",
        "def_en": "the things that people want or need to buy",
        "def_es": "Persona que compra o podría comprar lo que vendes",
        "ex_en": "Mister Rodriguez shared a customer need, a place to hold his messy mail.",
        "ex_es": "El señor Rodríguez es un cliente que necesitaba algo para guardar el correo.",
        "word_es": "cliente"
      },
      {
        "word": "demand",
        "def_en": "how much people want to buy something",
        "def_es": "La cantidad de clientes que quieren comprar un producto en un momento dado",
        "ex_en": "Demand was highest for key hooks, because five people asked for them.",
        "ex_es": "La demanda fue mayor para los ganchos, porque cinco personas los pidieron.",
        "word_es": "demanda"
      },
      {
        "word": "supply_and_demand",
        "def_en": "the amount of something that is made or available to sell",
        "def_es": "Principio económico: cuando hay poco de algo y mucha gente lo quiere, el precio sube; cuando hay mucho (sobreoferta), baja",
        "ex_en": "The friends knew supply should match demand, so they made key hooks before anything else.",
        "ex_es": "Los amigos sabían que la oferta y demanda deben equilibrarse, así que harían primero los ganchos para llaves.",
        "word_es": "oferta y demanda"
      },
      {
        "word": "community",
        "def_en": "the people who live near you",
        "def_es": "las personas que viven cerca de ti",
        "ex_en": "Riley's survey taught the friends what the community needs.",
        "ex_es": "La encuesta de Riley enseñó a los amigos qué necesita la comunidad.",
        "word_es": "comunidad"
      }
    ],
    "title_es": "LA INVESTIGACIÓN DE MERCADO",
    "summary_es": "Layla anuncia un próximo Mercado de Creadores y los amigos planifican con entusiasmo qué hacer. Ellis plantea la pregunta crucial de si alguien realmente querría sus productos. Layla propone encuestar al vecindario para averiguarlo. Los amigos diseñan una encuesta, visitan diez familias y luego analizan los datos de vuelta en el fuerte. Descubren patrones claros de demanda: los ganchos para llaves son lo más pedido, seguidos de los porta-plantas, y se dan cuenta de que investigar antes de producir previene el desperdicio de esfuerzo y materiales.",
    "fl_pillar_es": "Investigación de mercado, necesidades del cliente, demanda"
  },
  {
    "season": 3,
    "chapter": 11,
    "slug": "s3-ch11",
    "title": "THE CREATION WORKSHOP",
    "summary": "The friends arrive at the community workshop to produce items for the upcoming Maker's Market. They review their market research, set a production target, and divide labor based on each person's strengths. Ellis and Benny work at the woodworking station making key hooks while Riley and Layla work at the pottery station making plant holders. The idea of combination pieces -- wooden stands with ceramic pots -- emerges as an innovation. Through a full morning of focused production, they exceed their target, producing eighteen items that match verified customer demand.",
    "fl_pillar": "Production planning, division of labor, quality control, innovation through collaboration",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch11/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch11/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch11/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch11/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch11/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch11/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch11/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch11/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "planning",
        "def_en": "deciding what and how much to make",
        "def_es": "Pensar y organizar lo que se va a hacer antes de hacerlo",
        "ex_en": "Ellis thought about planning, and said fifteen items would give people choices.",
        "ex_es": "Ellis pensó en la planificación y dijo que quince piezas darían opciones a la gente.",
        "word_es": "planificación"
      },
      {
        "word": "quality",
        "def_en": "how good something is",
        "def_es": "Que algo esté bien hecho, con cuidado, y que dure mucho tiempo",
        "ex_en": "Ellis checked his finished key hook for quality.",
        "ex_es": "Ellis revisó la calidad de su gancho para llaves terminado.",
        "word_es": "calidad"
      },
      {
        "word": "quality_control",
        "def_en": "checking products to meet standards",
        "def_es": "Revisar que algo esté bien hecho y mantener la misma calidad cada vez",
        "ex_en": "Ellis checked the edges and mounting holes during quality control, because poor quality would hurt their reputation at the market.",
        "ex_es": "Ellis revisó los bordes y los agujeros en el control de calidad, porque algo mal hecho dañaría su reputación en el mercado.",
        "word_es": "control de calidad"
      },
      {
        "word": "division_of_labor",
        "def_en": "splitting up work so people do different tasks",
        "def_es": "Organización en la que cada persona se dedica a la tarea que mejor sabe hacer, logrando más con menos esfuerzo",
        "ex_en": "Division of labor let Riley focus on plant holders while Ellis made key hooks.",
        "ex_es": "La división del trabajo dejó a Riley con las macetas y a Ellis con los ganchos.",
        "word_es": "división del trabajo"
      },
      {
        "word": "craftsmanship",
        "def_en": "skill in making things by hand",
        "def_es": "Trabajo especializado que se aprende con práctica durante años",
        "ex_en": "Ellis took his time cutting the hook, because craftsmanship needs patience, not speed.",
        "ex_es": "Ellis se tomó su tiempo para cortar el gancho, porque la artesanía necesita paciencia y no prisa.",
        "word_es": "artesanía"
      },
      {
        "word": "prototype",
        "def_en": "creating something new by combining ideas",
        "def_es": "Crear algo nuevo: la primera versión que se construye para probarla (prototipo) y el ciclo de probar, fallar y ajustar (iteración)",
        "ex_en": "Layla's third pot was a better iteration than her first two tries.",
        "ex_es": "La tercera maceta de Layla fue una iteración mejor que sus dos primeros intentos.",
        "word_es": "prototipo"
      },
      {
        "word": "workshop",
        "def_en": "a room where people make things with tools",
        "def_es": "un cuarto donde la gente hace cosas con herramientas",
        "ex_en": "Layla, Riley, Ellis and Benny worked in the community workshop.",
        "ex_es": "Layla, Riley, Ellis y Benny trabajaron en el taller comunitario.",
        "word_es": "taller"
      }
    ],
    "title_es": "EL TALLER DE CREACIÓN",
    "summary_es": "Los amigos llegan al taller comunitario para producir artículos para el próximo Mercado de Creadores. Revisan su investigación de mercado, establecen una meta de producción y dividen el trabajo según las fortalezas de cada uno. Ellis y Benny trabajan en la estación de carpintería haciendo ganchos para llaves mientras Riley y Layla trabajan en la estación de alfarería haciendo porta-plantas. La idea de piezas combinadas, bases de madera con macetas de cerámica, surge como innovación. A través de una mañana completa de producción enfocada, superan su meta, produciendo dieciocho artículos que coinciden con la demanda verificada de los clientes.",
    "fl_pillar_es": "Planificación de producción, división del trabajo, control de calidad, innovación a través de la colaboración"
  },
  {
    "season": 3,
    "chapter": 12,
    "slug": "s3-ch12",
    "title": "THE MAKERS' FAIRE",
    "summary": "The friends bring their handmade products to the community Maker's Faire, setting up a professional booth with strategic pricing and display. As the day unfolds, they experience the full cycle of selling: customer interactions, wrapping purchases, making change, and watching their inventory deplete. Their three mentors -- Master Thomas, the Potter, and the Gearsmith -- each visit and express pride in the craftsmanship. By day's end, the friends count one hundred sixty dollars in revenue, subtract eighty dollars in expenses, and realize they earned eighty dollars in profit. Walking home, they reflect on the entire season's journey from learning skills to creating real value.",
    "fl_pillar": "Selling products, pricing, customer service, calculating profit",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch12/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch12/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch12/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch12/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch12/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch12/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s3/ch12/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s3/ch12/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "profit",
        "def_en": "money earned after paying all expenses",
        "def_es": "El dinero que queda después de restar todos los gastos de lo que se vendió",
        "ex_en": "At the Makers' Faire, after paying about eighty dollars for supplies and lessons, Layla and her friends kept eighty dollars in pure profit.",
        "ex_es": "En la Feria de Creadores, después de pagar unos ochenta dólares en materiales y lecciones, Layla y sus amigos se quedaron con ochenta dólares de ganancia.",
        "word_es": "ganancia"
      },
      {
        "word": "market_research",
        "def_en": "learning what people want before making products",
        "def_es": "Herramienta de investigación con preguntas organizadas para saber qué quiere la gente antes de producir",
        "ex_en": "Ellis hung price tags they had prepared during market research, so the prices reflected their work.",
        "ex_es": "Ellis colgó las etiquetas que prepararon con la investigación de mercado, para que los precios reflejaran su trabajo.",
        "word_es": "investigación de mercado"
      },
      {
        "word": "customer",
        "def_en": "a person who buys something",
        "def_es": "Persona que compra o podría comprar lo que vendes",
        "ex_en": "Layla said customers were coming to the booth.",
        "ex_es": "Layla dijo que ya venían los clientes al puesto.",
        "word_es": "cliente"
      },
      {
        "word": "display",
        "def_en": "how you show things to people",
        "def_es": "Muestra organizada de objetos para que otros los vean y los aprecien",
        "ex_en": "Layla set up the display with items at different heights.",
        "ex_es": "Layla armó la exhibición con cosas a distintas alturas.",
        "word_es": "exhibición"
      },
      {
        "word": "craftsmanship",
        "def_en": "skill in making things well",
        "def_es": "Trabajo especializado que se aprende con práctica durante años",
        "ex_en": "The Potter said Riley's steady hands showed real skill.",
        "ex_es": "La Alfarera dijo que las manos firmes de Riley mostraban oficio.",
        "word_es": "artesanía"
      },
      {
        "word": "marketplace",
        "def_en": "a big outdoor market where many sellers gather",
        "def_es": "un mercado grande al aire libre donde se juntan muchos vendedores",
        "ex_en": "Vendors lined the main walkway with booths, and the community park became a busy marketplace by morning.",
        "ex_es": "Los vendedores llenaron el pasillo principal con puestos, y el parque se volvió un mercado lleno de gente.",
        "word_es": "mercado"
      }
    ],
    "title_es": "LA FERIA DE CREADORES",
    "summary_es": "Los amigos llevan sus productos hechos a mano a la Feria de Creadores comunitaria, montando un puesto profesional con precios estratégicos y exhibición. A lo largo del día, experimentan el ciclo completo de la venta: interacciones con clientes, envolver compras, dar cambio y ver cómo se agota su inventario. Sus tres mentores, Master Thomas, la Alfarera y el Gearsmith, visitan cada uno y expresan orgullo por la artesanía. Al final del día, los amigos cuentan ciento sesenta dólares de ingresos, restan ochenta dólares de gastos y se dan cuenta de que ganaron ochenta dólares de ganancia. Caminando a casa, reflexionan sobre el recorrido completo de la temporada desde aprender habilidades hasta crear valor real.",
    "fl_pillar_es": "Vender productos, fijación de precios, servicio al cliente, cálculo de ganancias"
  },
  {
    "season": 4,
    "chapter": 1,
    "slug": "s4-ch01",
    "title": "GOING SOLO",
    "summary": "Three weeks after the Makers' Faire, demand hasn't stopped — 14 requests sit in Ellis's notebook. Each friend tries going solo to handle the workload: Riley takes pottery commissions, Ellis does repairs, Layla tries selling journals, Benny becomes an errand runner. By week's end, each has hit a different wall. They compare notes at the fort: combined, they made $58 for dozens of hours. Layla sees the pattern: \"What if those aren't four problems? They're one problem — we're each trying to do everything alone.\" They decide to merge into one business for a trial week.",
    "fl_pillar": "Entrepreneurship (identifying marketable skills); Supply meeting demand; The limits of solo operation; Opportunity cost (time vs. money earned); Division of labor benefits",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch1/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch1/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch1/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch1/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch1/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch1/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch1/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch1/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "profit",
        "def_en": "the money you keep after you pay for what you used",
        "def_es": "El dinero que queda después de restar todos los gastos de lo que se vendió",
        "ex_en": "Benny's profit was only five dollars.",
        "ex_es": "La ganancia de Benny fue de solo cinco dólares.",
        "word_es": "ganancia"
      },
      {
        "word": "revenue",
        "def_en": "the total money earned before subtracting costs",
        "def_es": "Todo el dinero que entra por las ventas, antes de descontar cualquier gasto",
        "ex_en": "The revenue of Layla, Riley, Ellis and Benny that week was a small pile of money that did not match their hard work.",
        "ex_es": "Los ingresos de Layla, Riley, Ellis y Benny esa semana eran un montoncito de dinero que no igualaba su trabajo duro.",
        "word_es": "ingresos"
      },
      {
        "word": "opportunity_cost",
        "def_en": "what you give up when you choose to do one thing instead of another",
        "def_es": "Lo que pierdes por elegir una cosa en vez de otra; el precio de usar tu tiempo en algo",
        "ex_en": "Each time Riley remade the mugs, her opportunity cost was the new pottery she could have made.",
        "ex_es": "Cada vez que Riley rehacía las tazas, su costo de oportunidad era la cerámica nueva que pudo haber hecho.",
        "word_es": "costo de oportunidad"
      },
      {
        "word": "division_of_labor",
        "def_en": "splitting up work so each person does what they are best at",
        "def_es": "Organización en la que cada persona se dedica a la tarea que mejor sabe hacer, logrando más con menos esfuerzo",
        "ex_en": "Riley thought dividing jobs by what each friend does best would bring more efficiency to the group.",
        "ex_es": "Riley pensó que dividir los trabajos según lo que cada amigo hace mejor daría más eficiencia al grupo.",
        "word_es": "división del trabajo"
      },
      {
        "word": "order_request",
        "def_en": "when someone asks you to do something for them",
        "def_es": "cuando alguien te paga para hacerle algo especial",
        "ex_en": "Benny ran an errand to mail a package for Mister Patel.",
        "ex_es": "Benny hizo un mandado para enviar un paquete del señor Patel.",
        "word_es": "pedidos"
      }
    ],
    "title_es": "VOLANDO SOLO",
    "summary_es": "Tres semanas después de la Feria de Creadores, los cuatro amigos intentan emprender por separado, repartiéndose los pedidos de la comunidad según sus habilidades individuales. Cada uno enfrenta un tipo diferente de fracaso: Riley sufre cambios constantes de una clienta difícil, Ellis pierde tiempo en desplazamientos ineficientes, Layla descubre que sus ganancias por hora son insosteniblemente bajas y Benny pierde el control de los pagos. Después de una semana decepcionante, Layla reconoce que cuatro problemas separados son en realidad un solo problema compartido: trabajar solos. Propone que se unan como un solo negocio.",
    "fl_pillar_es": "Emprendimiento, costo de oportunidad, división del trabajo"
  },
  {
    "season": 4,
    "chapter": 2,
    "slug": "s4-ch02",
    "title": "THE BUSINESS PLAN",
    "summary": "They name the business \"Maplewood Makers.\" Layla insists on a plan before selling anything. They visit Mr. Mason, who teaches them real costing: \"What does it cost to make? What will you charge? What happens when things go wrong?\" He introduces PRICE - COST = PROFIT. Frances asks \"Who are your customers?\" They build a pricing sheet, calculate startup costs ($60), design roles (Layla manages, Ellis builds, Riley creates, Benny sells and delivers), create an order system, and set aside an emergency fund.",
    "fl_pillar": "Business planning; Startup costs; Pricing strategy (PRICE - COST = PROFIT); Profit margins; Cost of goods sold; Target market identification; Role specialization; Emergency reserves",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch2/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch2/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch2/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch2/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch2/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch2/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch2/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch2/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "profit",
        "def_en": "the money you keep after you pay for what it cost to make something",
        "def_es": "El dinero que queda después de restar todos los gastos de lo que se vendió",
        "ex_en": "Layla and her friends found the PROFIT jar empty.",
        "ex_es": "Layla y sus amigos encontraron vacío el frasco de GANANCIAS.",
        "word_es": "ganancia"
      },
      {
        "word": "revenue",
        "def_en": "the total money earned from sales",
        "def_es": "Todo el dinero que entra por las ventas, antes de descontar cualquier gasto",
        "ex_en": "Ellis's pricing sheet showed that a shelf would bring fifteen dollars in revenue, before costs.",
        "ex_es": "La lista de precios de Ellis mostraba que un estante traería quince dólares de ingresos, antes de los costos.",
        "word_es": "ingresos"
      },
      {
        "word": "cost",
        "def_en": "how much money you pay for the things you need to make something",
        "def_es": "cuánto dinero pagas por las cosas que necesitas para hacer algo",
        "ex_en": "The cost of one shelf was six dollars.",
        "ex_es": "El costo de un estante era de seis dólares.",
        "word_es": "costo"
      },
      {
        "word": "emergency_fund",
        "def_en": "money you save just in case something goes wrong",
        "def_es": "Dinero reservado específicamente para cubrir gastos inesperados o problemas imprevistos",
        "ex_en": "Mister Mason's tool broke. Have an emergency fund, he said.",
        "ex_es": "Se rompió la herramienta del señor Mason. Ten un fondo de emergencia, dijo.",
        "word_es": "fondo de emergencia"
      },
      {
        "word": "order_form",
        "def_en": "a paper with spaces to write down what a customer wants",
        "def_es": "Documento estructurado con espacios designados para registrar información específica",
        "ex_en": "Layla made an order form for the friends.",
        "ex_es": "Layla hizo un formulario de pedido para los amigos.",
        "word_es": "formulario de pedido"
      },
      {
        "word": "pricing",
        "def_en": "deciding how much to charge customers",
        "def_es": "La decisión estratégica de fijar precios para comunicar calidad y tipo de cliente",
        "ex_en": "Pricing the shelf meant thinking about what was fair for customers and for their own time.",
        "ex_es": "Fijar precios para los estantes significaba pensar en lo justo para los clientes y para su tiempo.",
        "word_es": "fijar precios"
      },
      {
        "word": "partnership",
        "def_en": "an organization that makes or sells things to earn money",
        "def_es": "Personas que comparten la propiedad, las responsabilidades y las ganancias de un negocio",
        "ex_en": "The four friends began their partnership at the fort on Monday morning.",
        "ex_es": "Los cuatro amigos empezaron su sociedad en el fuerte el lunes por la mañana.",
        "word_es": "sociedad"
      }
    ],
    "title_es": "EL PLAN DE NEGOCIOS",
    "summary_es": "Habiendo acordado trabajar en equipo, los amigos dedican el capítulo a construir un plan de negocios real desde cero. Eligen un nombre, aprenden la fórmula de ganancias con Mister Mason, definen a sus clientes objetivo con la orientación de Frances, asignan roles según las fortalezas individuales, calculan los costos iniciales, reúnen sus ahorros, crean un sistema de frascos para el manejo del dinero y diseñan formularios de pedido y una lista de precios. Al final, su mentor aprueba el plan y están listos para abrir el negocio.",
    "fl_pillar_es": "Planificación de negocios, fijación de precios, cálculo de ganancias, costos iniciales"
  },
  {
    "season": 4,
    "chapter": 3,
    "slug": "s4-ch03",
    "title": "OPEN FOR BUSINESS",
    "summary": "First week of real operations. They install Mrs. Torres's shelf ($15, $10.50 profit), fix a gate on Elm Street ($20 + $5 tip), deliver a custom 6-mug set ($48), and take on several smaller jobs. Benny discovers that selling isn't convincing — it's listening to what people need. End of week: $93 revenue, $22 materials, $71 profit. But Layla spots a concern: 60% came from two big orders. \"What if next week we don't get a big order?\"",
    "fl_pillar": "Revenue (money coming in); First sales / customer acquisition; Tracking income and expenses; Tips as income; Revenue concentration risk; Profit calculation (revenue minus costs); Customer relationships",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch3/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch3/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch3/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch3/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch3/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch3/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch3/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch3/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "profit",
        "def_en": "the money you keep after you pay for what you used",
        "def_es": "El dinero que queda después de restar todos los gastos de lo que se vendió",
        "ex_en": "Everyone cheered when money went into the profit jar.",
        "ex_es": "Todos aplaudieron cuando entró dinero al frasco de ganancias.",
        "word_es": "ganancia"
      },
      {
        "word": "revenue",
        "def_en": "total money earned from customers before subtracting costs",
        "def_es": "Todo el dinero que entra por las ventas, antes de descontar cualquier gasto",
        "ex_en": "The shelf, the gate, the mugs and the small jobs all added to the week's revenue.",
        "ex_es": "El estante, el portón, las tazas y los trabajos chicos sumaron a los ingresos de la semana.",
        "word_es": "ingresos"
      },
      {
        "word": "tip",
        "def_en": "extra money a customer gives you for doing really good work",
        "def_es": "Pago voluntario adicional que un cliente entrega cuando el resultado supera sus expectativas",
        "ex_en": "Ellis got a tip for fixing the gate.",
        "ex_es": "Ellis recibió una propina por arreglar el portón.",
        "word_es": "propina"
      },
      {
        "word": "risk",
        "def_en": "when most income comes from just a few sources, creating risk",
        "def_es": "La posibilidad de que algo salga mal o de perder dinero, como cuando casi todos los ingresos dependen de muy pocos clientes (concentración de clientes)",
        "ex_en": "Layla saw the risk, because most of the week's money came from just two big jobs.",
        "ex_es": "Layla vio el riesgo, porque casi todo el dinero de la semana venía de solo dos trabajos grandes.",
        "word_es": "riesgo"
      },
      {
        "word": "customer",
        "def_en": "a person who pays for products or services",
        "def_es": "Persona que compra o podría comprar lo que vendes",
        "ex_en": "A nervous customer told Benny she did not have much money.",
        "ex_es": "Una clienta nerviosa le dijo a Benny que no tenía mucho dinero.",
        "word_es": "cliente"
      },
      {
        "word": "reputation",
        "def_en": "when a happy customer tells other people about you",
        "def_es": "La opinión colectiva que otros tienen sobre la calidad y confiabilidad de un negocio",
        "ex_en": "Good work gave the friends a good reputation.",
        "ex_es": "El buen trabajo les dio buena reputación a los amigos.",
        "word_es": "reputación"
      }
    ],
    "title_es": "ABIERTO AL PÚBLICO",
    "summary_es": "Los Creadores de Maplewood abren su negocio y tienen una primera semana exitosa. Completan su primera venta, reciben una propina, entregan un pedido grande de cerámica personalizada y manejan numerosos trabajos pequeños. En el conteo semanal, los ingresos son impresionantes. Pero el análisis de Layla revela que la mayor parte de los ingresos provino de solo dos pedidos grandes, exponiendo un riesgo de concentración de clientes. El capítulo termina con una nota de celebración pero cautelosa: el negocio funciona, pero necesitan más clientes para reducir la dependencia de unas pocas ventas grandes.",
    "fl_pillar_es": "Ingresos, ganancias, relaciones con clientes, publicidad de boca en boca, riesgo de concentración de clientes"
  },
  {
    "season": 4,
    "chapter": 4,
    "slug": "s4-ch04",
    "title": "THE UNHAPPY CUSTOMER",
    "summary": "Riley pours her heart into a decorative platter — blue flowers, her best work yet. The customer says: \"It's beautiful work. But it's not what I had in mind.\" They have to redo it — doubling materials cost and time. The team creates a new rule: for custom orders over $10, show a sketch before starting. Riley turns the rejected platter into a new \"artist's choice\" product line. A separate quality issue (slightly leaning birdhouse) gets fixed for free, earning word-of-mouth praise.",
    "fl_pillar": "Customer satisfaction; Quality control; Refunds vs. redos (cost implications); Reputation management; Managing customer expectations; Turning mistakes into opportunities; The cost of rework; Customer communication",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch4/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch4/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch4/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch4/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch4/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch4/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch4/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch4/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "quality",
        "def_en": "how good something is",
        "def_es": "Que algo esté bien hecho, con cuidado, y que dure mucho tiempo",
        "ex_en": "The cream plate with blue flowers had good quality.",
        "ex_es": "El plato crema con flores azules tenía buena calidad.",
        "word_es": "calidad"
      },
      {
        "word": "reputation",
        "def_en": "feeling happy with what you got",
        "def_es": "La opinión colectiva que otros tienen sobre la calidad y confiabilidad de un negocio",
        "ex_en": "Riley made the plate again to keep a good reputation.",
        "ex_es": "Riley rehízo el plato para mantener una buena reputación.",
        "word_es": "reputación"
      },
      {
        "word": "capacity_limit",
        "def_en": "doing the same job over again to fix it",
        "def_es": "volver a hacer el mismo trabajo para arreglarlo",
        "ex_en": "Riley had to rework the plate with roses.",
        "ex_es": "Riley tuvo que rehacer el plato con rosas.",
        "word_es": "límite de capacidad"
      }
    ],
    "title_es": "EL CLIENTE INSATISFECHO",
    "summary_es": "Una clienta del café le encarga a Riley un plato decorativo, dándole libertad creativa. Riley dedica toda su habilidad a una pieza que considera su mejor trabajo, pero la clienta la rechaza porque el diseño no coincide con sus preferencias no expresadas. La reelaboración casi elimina la ganancia del pedido. Mientras tanto, Ellis descubre y arregla voluntariamente un defecto en su propio trabajo, ganándose la confianza y generando recomendaciones. El equipo crea una nueva política que requiere mostrar bocetos antes de comenzar pedidos personalizados costosos. Layla también sugiere que Riley ofrezca una línea de \"elección del artista\" para compradores que quieran su visión creativa, convirtiendo la pieza rechazada en una venta en el café y dándole a Riley una manera sostenible de equilibrar la expresión artística con las expectativas del cliente.",
    "fl_pillar_es": "Satisfacción del cliente, expectativas de calidad, costos de reelaboración, gestión de reputación"
  },
  {
    "season": 4,
    "chapter": 5,
    "slug": "s4-ch05",
    "title": "THE COMPETITION",
    "summary": "An older boy named Neville starts undercutting every Maplewood Makers product — shelves for $10 (vs. their $15), repairs for $12 (vs. their $20). Panic sets in. Ellis wants to drop prices immediately. Layla stops him: \"If we charge $8 for a shelf, our profit is $3.50 before counting our time. We'd be working for pennies.\" They define their competitive advantage: custom designs, quality craftsmanship, personal service, and warranty. They raise prices slightly to signal quality. A customer who bought from Neville calls them when his shelf falls off the wall after one week.",
    "fl_pillar": "Competition and market dynamics; Competitive advantage; Differentiation strategy; Price positioning (quality premium); Market segmentation (not everyone wants the cheapest option); Pricing psychology; Value proposition; Race to the bottom vs. value creation",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch5/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch5/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch5/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch5/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch5/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch5/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch5/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch5/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "guarantee",
        "def_en": "a promise that your work will be done right",
        "def_es": "Compromiso formal de reparar o reemplazar un producto que falle dentro de un período determinado",
        "ex_en": "Ellis wanted a guarantee, so the friends made a card to promise their work.",
        "ex_es": "Ellis quiso una garantía, así que los amigos hicieron una tarjeta para prometer su trabajo.",
        "word_es": "garantía"
      },
      {
        "word": "pricing",
        "def_en": "choosing where your price sits compared to others, and what that signals",
        "def_es": "La decisión estratégica de fijar precios para comunicar calidad y tipo de cliente",
        "ex_en": "Layla's pricing choice raised a shelf to eighteen dollars to show its worth.",
        "ex_es": "Layla decidió fijar precios más altos, dieciocho dólares por estante, para mostrar valor.",
        "word_es": "fijar precios"
      },
      {
        "word": "quality",
        "def_en": "how good something is and how long it lasts",
        "def_es": "Que algo esté bien hecho, con cuidado, y que dure mucho tiempo",
        "ex_en": "Riley said their work lasts, and that is quality.",
        "ex_es": "Riley dijo que su trabajo dura, y eso es calidad.",
        "word_es": "calidad"
      },
      {
        "word": "competition",
        "def_en": "when another business offers the same kind of products or services",
        "def_es": "Cuando otra persona o negocio ofrece lo mismo que tú; la ventaja competitiva es la fortaleza que te hace ganar",
        "ex_en": "Missus Chen hired the other boy, so the competition took a customer.",
        "ex_es": "La señora Chen contrató al otro chico, y la competencia les quitó un cliente.",
        "word_es": "competencia"
      }
    ],
    "title_es": "LA COMPETENCIA",
    "summary_es": "Un competidor más barato llamado Neville aparece en el vecindario, ofreciendo precios más bajos que los Creadores de Maplewood en cada producto. Ellis entra en pánico y quiere igualar los precios bajos, pero Layla demuestra que hacerlo reduciría sus ganancias a casi nada. Tras el consejo de Mister Mason, el equipo decide subir los precios, garantizar su trabajo y competir en calidad. Cuando el trabajo descuidado de Neville falla para una clienta, la voz se corre, y nuevos clientes eligen a los Creadores de Maplewood específicamente porque hacen el trabajo bien.",
    "fl_pillar_es": "Competencia, ventaja competitiva, diferenciación, posicionamiento de precios"
  },
  {
    "season": 4,
    "chapter": 6,
    "slug": "s4-ch06",
    "title": "HIDDEN COSTS",
    "summary": "Three things hit at once: Ellis's saw blade snaps ($12 replacement), Riley's glaze runs out ($18 refill), and Layla realizes they've been using Mr. Mason's workshop electricity for free. They discover \"overhead\" — the costs that don't show up in material lists. They recalculate past profits, adjusting for tool depreciation, electricity usage, supply restocking, and bulk purchasing opportunities. True profit over four weeks: $155 (not $217 as they thought). An eye-opening but necessary correction.",
    "fl_pillar": "Overhead costs; True cost accounting; Tool depreciation; Supply restocking; Bulk purchasing benefits; Hidden expenses; Adjusted profit margins; Cost of doing business",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch6/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch6/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch6/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch6/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch6/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch6/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch6/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch6/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "cost",
        "def_en": "the full price of doing business, including hidden expenses",
        "def_es": "el precio completo de un negocio, contando los gastos escondidos",
        "ex_en": "Layla added up the hidden costs the friends never counted.",
        "ex_es": "Layla sumó los costos escondidos que los amigos nunca contaron.",
        "word_es": "costo"
      },
      {
        "word": "overhead",
        "def_en": "costs you pay just to keep working, like lights and tools wearing out",
        "def_es": "Gastos que un negocio tiene aunque no esté produciendo nada — el costo de existir como negocio",
        "ex_en": "Mister Mason's overhead sheet listed rent, electricity, and sandpaper.",
        "ex_es": "La hoja de costos indirectos del señor Mason tenía alquiler, luz y lija.",
        "word_es": "costos indirectos"
      },
      {
        "word": "depreciation",
        "def_en": "tools and equipment wearing out and losing value through normal use",
        "def_es": "La pérdida de valor que sufre una herramienta o equipo con el uso continuo",
        "ex_en": "Ellis's saw blade broke from use, and that wear is depreciation.",
        "ex_es": "La hoja de sierra de Ellis se rompió por el uso, y ese desgaste es depreciación.",
        "word_es": "depreciación"
      },
      {
        "word": "reserves",
        "def_en": "money you set aside to use later when you need it",
        "def_es": "Dinero guardado a propósito para cubrir gastos futuros que se sabe que van a llegar",
        "ex_en": "They made a reserve jar for new tools.",
        "ex_es": "Hicieron un frasco de reserva para herramientas nuevas.",
        "word_es": "reserva"
      },
      {
        "word": "budget",
        "def_en": "your plan for how much money you have and how you will spend it",
        "def_es": "Estimación anticipada de cuánto costará un trabajo y cuánto se cobrará; el plan de gastos",
        "ex_en": "The twelve dollar blade was not in the budget.",
        "ex_es": "La hoja de doce dólares no estaba en el presupuesto.",
        "word_es": "presupuesto"
      },
      {
        "word": "bulk_purchasing",
        "def_en": "buying a big amount at once so each piece costs less",
        "def_es": "Comprar grandes cantidades de un material para que el costo por unidad sea menor",
        "ex_en": "Mister Mason does bulk buying, so his sandpaper costs less.",
        "ex_es": "El señor Mason compra al por mayor, así su lija cuesta menos.",
        "word_es": "compra al por mayor"
      }
    ],
    "title_es": "COSTOS OCULTOS",
    "summary_es": "Después de que la hoja de sierra de Ellis se rompe y el esmalte de Riley se agota, Layla se da cuenta de que el equipo nunca ha contabilizado los costos indirectos del negocio. Una visita al taller de Mister Mason revela toda una categoría de gastos — los costos indirectos — que han estado ignorando. Layla obliga a un recálculo honesto de sus ganancias, moviendo dinero del frasco de ganancias al de costos, y el equipo implementa nuevos sistemas: precios ajustados, compras al por mayor y un fondo de reserva para futuras reposiciones de herramientas.",
    "fl_pillar_es": "Costos indirectos, depreciación de herramientas, contabilidad de costos reales, compras al por mayor"
  },
  {
    "season": 4,
    "chapter": 7,
    "slug": "s4-ch07",
    "title": "TOO MUCH WORK",
    "summary": "Benny promises seven new orders in one week — on top of four existing orders. The team's realistic capacity is about six orders total per week. They're at nearly double capacity. Everything suffers: quality issues, missed deadlines, rushed work, exhausted kids. They create Benny's Capacity Card system: a green/yellow/red card that Layla updates daily showing current workload. Benny carries it when talking to customers. Revenue hits $132 (highest ever), but profit per hour went DOWN because of waste and overtime.",
    "fl_pillar": "Capacity limits (you can only do so much); Overcommitting consequences; Delivery timelines; The cost of rushing (quality suffers, waste increases); Demand management; Waitlist psychology (making customers wait can build value); Profit per hour vs. total profit; Sustainable growth vs. burnout",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch7/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch7/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch7/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch7/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch7/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch7/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch7/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch7/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "profit",
        "def_en": "the money you keep after you pay for what you used",
        "def_es": "El dinero que queda después de restar todos los gastos de lo que se vendió",
        "ex_en": "The ruined board cost four dollars of their profit.",
        "ex_es": "La tabla arruinada se llevó cuatro dólares de su ganancia.",
        "word_es": "ganancia"
      },
      {
        "word": "net_profit",
        "def_en": "how much money you earn for each hour you work",
        "def_es": "El beneficio real que queda después de restar todos los costos de los ingresos totales",
        "ex_en": "Ellis could not believe their profit per hour was lower after such a hard week.",
        "ex_es": "Ellis no podía creer que su ganancia por hora fuera menor después de una semana tan dura.",
        "word_es": "ganancia neta"
      },
      {
        "word": "capacity_investment",
        "def_en": "the most work you can do without rushing",
        "def_es": "La cantidad máxima de trabajo o productos que un equipo puede hacer en un tiempo dado",
        "ex_en": "The red card said the team had no capacity.",
        "ex_es": "La tarjeta roja decía que el equipo no tenía capacidad.",
        "word_es": "capacidad"
      },
      {
        "word": "capacity_limit",
        "def_en": "promising to do more than you can finish",
        "def_es": "prometer hacer más de lo que puedes terminar",
        "ex_en": "Benny was overcommitting when he promised seven more orders without asking the team.",
        "ex_es": "Benny se comprometió de más cuando prometió siete pedidos nuevos sin preguntarle al equipo.",
        "word_es": "límite de capacidad"
      },
      {
        "word": "demand",
        "def_en": "controlling how much work you accept to maintain quality standards",
        "def_es": "La cantidad de clientes que quieren comprar un producto en un momento dado",
        "ex_en": "Seven new orders in one week was more demand than the team could handle, so Layla's card helped manage it.",
        "ex_es": "Siete pedidos nuevos en una semana eran más demanda de la que el equipo podía atender, así que la tarjeta de Layla ayudó a controlarla.",
        "word_es": "demanda"
      }
    ],
    "title_es": "DEMASIADO TRABAJO",
    "summary_es": "Benny, ansioso por hacer felices a los clientes, acepta por su cuenta siete pedidos nuevos además de los cuatro existentes, casi el doble de su capacidad semanal. El equipo se lanza a una semana agotadora de trabajo apresurado, errores, plazos incumplidos y calidad comprometida. Cuando cuentan el dinero, establecen un récord de ingresos, pero el análisis de Layla revela que su ganancia por hora en realidad bajó porque trabajar apurado causó desperdicio e ineficiencia. Benny aprende que decir que sí a todo no ayuda a nadie, y el equipo crea un sistema de tarjeta de capacidad para prevenir el sobrecompromiso.",
    "fl_pillar_es": "Límites de capacidad, sobrecompromiso, costos de trabajar apurado, ganancia por hora"
  },
  {
    "season": 4,
    "chapter": 8,
    "slug": "s4-ch08",
    "title": "THE PIVOT",
    "summary": "Month two begins. Revenue plateaus around $90-95 per week despite more effort. Layla reviews the data: pottery = 60% of revenue (growing), repairs = 25% (stable), birdhouses = 10% (declining), journals = 5% (dead). Painful decisions: birdhouses become order-only (stop making inventory). Layla kills her own product line — journals — that SHE loves but the market doesn't. Two weeks post-pivot: revenue $115 (up), costs $26 (down), profit $89 (best ever). The map reveals customer demand clusters.",
    "fl_pillar": "Pivoting (strategic product changes); Reading market signals; Data-driven decisions; Opportunity cost (time spent on journals could go to pottery); Dropping unprofitable products; Revenue by product category; Seasonal product planning; Focus vs. diversification",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch8/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch8/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch8/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch8/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch8/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch8/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch8/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch8/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "revenue",
        "def_en": "the total money a business earns before subtracting costs",
        "def_es": "Todo el dinero que entra por las ventas, antes de descontar cualquier gasto",
        "ex_en": "Revenue rose to one hundred and seven dollars in the first week after the change.",
        "ex_es": "Los ingresos subieron a ciento siete dólares la primera semana después del cambio.",
        "word_es": "ingresos"
      },
      {
        "word": "opportunity_cost",
        "def_en": "what you give up when you choose one thing over another",
        "def_es": "Lo que pierdes por elegir una cosa en vez de otra; el precio de usar tu tiempo en algo",
        "ex_en": "Journals had an opportunity cost, because they used two or three hours of Layla's week.",
        "ex_es": "Los diarios tenían un costo de oportunidad, porque usaban dos o tres horas de la semana de Layla.",
        "word_es": "costo de oportunidad"
      },
      {
        "word": "business_cycle",
        "def_en": "a pattern that shows something going up or down over time",
        "def_es": "Los pasos completos de un negocio o el patrón que se repite — incluyendo las temporadas altas y bajas",
        "ex_en": "The pottery trend went up every week.",
        "ex_es": "La tendencia de la cerámica subía cada semana.",
        "word_es": "ciclo de negocio"
      },
      {
        "word": "division_of_labor",
        "def_en": "concentrating resources on what works best instead of spreading them too thin",
        "def_es": "Organización en la que cada persona se dedica a la tarea que mejor sabe hacer, logrando más con menos esfuerzo",
        "ex_en": "With Layla preparing clay and Riley shaping pottery, the friends used division of labor to make more pieces without rushing.",
        "ex_es": "Con Layla preparando la arcilla y Riley moldeando, la división del trabajo les permitió hacer más piezas sin apurarse.",
        "word_es": "división del trabajo"
      },
      {
        "word": "pivot",
        "def_en": "changing direction in a business to focus on what works better",
        "def_es": "Cambiar la dirección de un negocio basándose en datos",
        "ex_en": "After the pivot, Layla stopped making journals and helped Riley with pottery.",
        "ex_es": "Después del cambio de rumbo, Layla dejó los diarios y ayudó a Riley con la cerámica.",
        "word_es": "cambio de rumbo"
      },
      {
        "word": "bar_chart",
        "def_en": "a picture with bars that helps you compare how much each thing earns",
        "def_es": "un dibujo con barras que ayuda a comparar cuánto gana cada cosa",
        "ex_en": "Layla made a bar chart with four bars.",
        "ex_es": "Layla hizo una gráfica de barras con cuatro barras.",
        "word_es": "gráfica de barras"
      }
    ],
    "title_es": "EL CAMBIO DE RUMBO",
    "summary_es": "Cinco semanas después de iniciar el negocio, los ingresos se han estancado. Layla analiza los datos y descubre que la cerámica genera la mayor parte de sus ingresos y está creciendo, mientras que sus diarios hechos a mano dejaron de venderse por completo. Debe tomar la dolorosa decisión de eliminar su propio producto. Después de una conversación con Frances sobre la poda, Layla retira los diarios de la oferta, liberando tiempo para que Riley aumente la producción de cerámica. Las ganancias suben inmediatamente a niveles récord, demostrando que eliminar lo que no funciona fortalece todo lo demás.",
    "fl_pillar_es": "Pivoteo, señales del mercado, costo de oportunidad, decisiones basadas en datos, poda"
  },
  {
    "season": 4,
    "chapter": 9,
    "slug": "s4-ch09",
    "title": "THE PARTNERSHIP",
    "summary": "Ellen, the café owner, approaches the kids with a business proposition: she wants to sell their pottery in her shop. New territory — business-to-business relationships. Mr. Mason explains consignment: they leave products with Ellen, the café takes a percentage of sales (not buying wholesale), unsold items return to them. They negotiate: 30% to café for first month, 35% ongoing after that. First week: 3 of 6 mugs sell. They create a simple written agreement. A new revenue stream begins.",
    "fl_pillar": "Business-to-business partnerships (B2B); Consignment model (vs. wholesale or direct sales); Negotiation and deal structure; Percentage-based compensation; Passive income (products sell when they're not there); Written agreements; Multiple revenue streams; Risk-sharing arrangements",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch9/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch9/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch9/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch9/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch9/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch9/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch9/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch9/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "written_agreement",
        "def_en": "writing down the rules so nobody forgets",
        "def_es": "escribir las reglas para que nadie las olvide",
        "ex_en": "Layla made a written agreement so nobody forgets.",
        "ex_es": "Layla hizo un acuerdo escrito para no olvidar nada.",
        "word_es": "acuerdo escrito"
      },
      {
        "word": "bulk_purchasing",
        "def_en": "buying products in bulk at a lower price to resell later",
        "def_es": "Comprar grandes cantidades de un material para que el costo por unidad sea menor",
        "ex_en": "Layla asked how consignment is different from wholesale, where someone buys in bulk at a lower price.",
        "ex_es": "Layla preguntó en qué se diferencia la consignación de la venta al por mayor, donde alguien compra en grandes cantidades a menor precio.",
        "word_es": "compra al por mayor"
      },
      {
        "word": "consignment",
        "def_en": "leaving your things at a friend's shop for them to sell, then sharing the money",
        "def_es": "Acuerdo comercial en el que los productos se exhiben en otro negocio y el fabricante recibe pago únicamente cuando se venden",
        "ex_en": "Ellen's cafe sells the mugs on consignment.",
        "ex_es": "Ellen vende las tazas en su café en consignación.",
        "word_es": "consignación"
      },
      {
        "word": "partnership",
        "def_en": "when two groups work together so both can do better",
        "def_es": "Personas que comparten la propiedad, las responsabilidades y las ganancias de un negocio",
        "ex_en": "Ellen and the friends have a partnership.",
        "ex_es": "Ellen y los amigos ahora son socios.",
        "word_es": "sociedad"
      },
      {
        "word": "negotiate",
        "def_en": "talking about what is fair for everyone",
        "def_es": "Hablar sobre el precio hasta llegar a un acuerdo justo entre dos personas",
        "ex_en": "Benny negotiated with Ellen about the money.",
        "ex_es": "Benny negoció con Ellen sobre el dinero.",
        "word_es": "negociar"
      }
    ],
    "title_es": "LA SOCIEDAD",
    "summary_es": "La dueña de un café local se acerca al equipo con una propuesta para vender su cerámica en consignación. Con la guía de Mister Mason, los amigos aprenden la diferencia entre consignación y venta al por mayor. Benny toma la iniciativa para negociar la división de ingresos, asegurando términos más favorables. El equipo formaliza el acuerdo por escrito, entrega los productos y experimenta su primera semana de ingresos pasivos a través de una asociación entre negocios, expandiendo su red comercial en una nueva dirección.",
    "fl_pillar_es": "Asociaciones entre negocios, consignación, negociación, acuerdos escritos"
  },
  {
    "season": 4,
    "chapter": 10,
    "slug": "s4-ch10",
    "title": "THE SEASONAL RUSH",
    "summary": "Holiday season arrives. Demand spikes dramatically. Strategy: pre-orders with 50% deposit upfront to manage cash flow and commitment. Riley discovers batch production — making 14 ornaments in batches of 7 takes 8 hours instead of 14 hours (efficiency gains). The café reorders pottery twice. Holiday month: $396 total revenue, $243 profit. But Layla insists on setting aside 30% ($73) as reserve for slow season ahead. Four kids, four different approaches to their windfall earnings.",
    "fl_pillar": "Seasonal demand (holiday rush); Inventory planning; Pre-orders and customer deposits; Upfront deposits (reducing risk); Batch production efficiency; Revenue spikes (temporary vs. sustained); Building reserves for slow periods; Cash flow management",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch10/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch10/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch10/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch10/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch10/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch10/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch10/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch10/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "scarcity",
        "def_en": "when something is limited, making people want it more",
        "def_es": "Escasez es cuando hay muy poco de algo; abundancia es cuando hay mucho más de lo necesario",
        "ex_en": "Scarcity made people want the ornaments more once the order board was full.",
        "ex_es": "Con el tablero lleno, la escasez hizo que la gente quisiera más los adornos.",
        "word_es": "escasez"
      },
      {
        "word": "reserves",
        "def_en": "money deliberately saved for slower times when income decreases",
        "def_es": "Dinero guardado a propósito para cubrir gastos futuros que se sabe que van a llegar",
        "ex_en": "Layla persuaded her friends to vote for a reserve, because January would be slow after the holiday spending.",
        "ex_es": "Layla convenció a sus amigos de votar por una reserva, porque enero sería lento después de los gastos de diciembre.",
        "word_es": "reserva"
      },
      {
        "word": "deposit",
        "def_en": "money a customer pays first, before the work is done",
        "def_es": "Dinero que se paga por adelantado como parte del precio total para asegurar un pedido",
        "ex_en": "Missus Torres paid half as a deposit.",
        "ex_es": "La señora Torres pagó la mitad como depósito.",
        "word_es": "depósito"
      },
      {
        "word": "capacity_investment",
        "def_en": "how much work you can do in the time you have",
        "def_es": "La cantidad máxima de trabajo o productos que un equipo puede hacer en un tiempo dado",
        "ex_en": "Benny's card turned red. They had no more capacity.",
        "ex_es": "La tarjeta de Benny se puso roja. No había más capacidad.",
        "word_es": "capacidad"
      },
      {
        "word": "business_cycle",
        "def_en": "times when customers want products more than usual",
        "def_es": "Los pasos completos de un negocio o el patrón que se repite — incluyendo las temporadas altas y bajas",
        "ex_en": "After the holiday passed, seasonal demand fell and people stopped ordering as much.",
        "ex_es": "Después de la Navidad, el ciclo estacional bajó y la gente pidió menos.",
        "word_es": "ciclo de negocio"
      },
      {
        "word": "batch_production",
        "def_en": "making lots of the same thing together to save time",
        "def_es": "Método de fabricar muchas piezas idénticas en un solo grupo para reducir el tiempo por unidad",
        "ex_en": "Riley made seven ornaments together with batch production.",
        "ex_es": "Riley hizo siete adornos juntos con producción por lotes.",
        "word_es": "producción por lotes"
      },
      {
        "word": "scaling",
        "def_en": "cost advantages gained by producing larger quantities",
        "def_es": "El proceso de hacer crecer un negocio rápidamente, agregando empleados, espacio y productos",
        "ex_en": "Ellen ordered twelve more mugs, her biggest order yet, and the cafe partnership was scaling up nicely.",
        "ex_es": "Ellen pidió doce tazas más, su pedido más grande, y la relación con el café estaba escalando.",
        "word_es": "escalar"
      },
      {
        "word": "order_request",
        "def_en": "when customers order and pay for something before it is made",
        "def_es": "Encargos que alguien te hace para que le hagas o le traigas algo — incluyendo prepedidos pagados por adelantado",
        "ex_en": "Missus Torres ordered six ornaments and paid half before they were made.",
        "ex_es": "La señora Torres hizo un pedido de seis adornos y pagó la mitad antes.",
        "word_es": "pedidos"
      }
    ],
    "title_es": "LA TEMPORADA ALTA",
    "summary_es": "La temporada navideña de diciembre trae un aumento de demanda que pone a prueba la capacidad del equipo. Riley inventa un método de producción por lotes que duplica su producción, mientras Layla introduce depósitos y prepedidos para gestionar el flujo de efectivo. El equipo experimenta su mes más rentable hasta ahora, pero Layla los convence de apartar reservas para la inevitable desaceleración de enero. La decisión de gasto de cada miembro del equipo después del reparto de ganancias revela sus valores individuales.",
    "fl_pillar_es": "Prepedidos, depósitos, gestión de capacidad, producción por lotes, reservas"
  },
  {
    "season": 4,
    "chapter": 11,
    "slug": "s4-ch11",
    "title": "THE SLOW SEASON",
    "summary": "January arrives. Demand crashes — first week brings only $18 in revenue. The holiday high is over. The reserve fund prevents panic. Frances offers a garden metaphor: \"Everything looks dead. But underground, the roots are growing.\" They shift to maintenance mode: invest in better packaging, build spring inventory, improve systems. Surprise: a wedding order for 30 custom pottery favors ($180) arrives from a referral — proof that reputation and network matter more than constant hustle.",
    "fl_pillar": "Seasonal slowdowns (cyclical business patterns); Purpose of reserves (buffer for slow periods); Maintenance vs. growth mode; Investing during downtime; Long-term customer retention; Seasonal business planning; Referral value (relationship ROI); Patient capital",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch11/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch11/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch11/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch11/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch11/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch11/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch11/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch11/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "reserves",
        "def_en": "money saved during good times to use during slow times",
        "def_es": "Dinero guardado a propósito para cubrir gastos futuros que se sabe que van a llegar",
        "ex_en": "Layla took the reserve jar from the shelf and said it was why they saved.",
        "ex_es": "Layla bajó el frasco de reserva del estante y dijo que por eso ahorraron.",
        "word_es": "reserva"
      },
      {
        "word": "investment",
        "def_en": "using business money to improve tools or systems",
        "def_es": "Poner algo de valor (tiempo, esfuerzo, dinero) con la esperanza de que crezca y produzca más",
        "ex_en": "Layla spent twelve dollars of reserve money on boxes, paper and thank you cards, a small investment for spring orders.",
        "ex_es": "Layla gastó doce dólares de la reserva en cajas, papel y tarjetas de agradecimiento, una pequeña inversión para la primavera.",
        "word_es": "inversión"
      },
      {
        "word": "business_cycle",
        "def_en": "when business is busy during some times of year and slow during others",
        "def_es": "Los pasos completos de un negocio o el patrón que se repite — incluyendo las temporadas altas y bajas",
        "ex_en": "Frances understood seasonal cycles, so her winter garden did not worry her.",
        "ex_es": "Frances conocía los ciclos de las estaciones, y su jardín en invierno no la preocupaba.",
        "word_es": "ciclo de negocio"
      },
      {
        "word": "reputation",
        "def_en": "when a satisfied customer tells others about your business",
        "def_es": "La opinión colectiva que otros tienen sobre la calidad y confiabilidad de un negocio",
        "ex_en": "The team's good reputation led Missus Torres to tell Miss Rivera about their pottery.",
        "ex_es": "La buena reputación del equipo llevó a la señora Torres a hablarle de ellos a Miss Rivera.",
        "word_es": "reputación"
      },
      {
        "word": "inventory",
        "def_en": "things you make ahead of time so they are ready to sell",
        "def_es": "Productos que se preparan con anticipación para tenerlos listos cuando alguien los pida",
        "ex_en": "Riley made spring bowls to build inventory.",
        "ex_es": "Riley hizo tazones de primavera para tener inventario.",
        "word_es": "inventario"
      },
      {
        "word": "partnership",
        "def_en": "ongoing connection with another business that helps both",
        "def_es": "Personas que comparten la propiedad, las responsabilidades y las ganancias de un negocio",
        "ex_en": "Ellen's cafe kept ordering in January, so the partnership helped when others stopped.",
        "ex_es": "El café de Ellen siguió pidiendo en enero, y la sociedad ayudó cuando otros dejaron de comprar.",
        "word_es": "sociedad"
      },
      {
        "word": "demand",
        "def_en": "how much people want to buy what you make",
        "def_es": "La cantidad de clientes que quieren comprar un producto en un momento dado",
        "ex_en": "Nobody was buying pottery yet, but demand would come back.",
        "ex_es": "Nadie compraba aún, pero la demanda iba a volver.",
        "word_es": "demanda"
      }
    ],
    "title_es": "LA TEMPORADA BAJA",
    "summary_es": "Llega enero y el negocio cae bruscamente después de la temporada navideña. El equipo enfrenta la realidad de la demanda estacional y recurre a su fondo de reserva para mantenerse a flote. Frances les enseña que los períodos lentos son para el crecimiento invisible: construir sistemas, habilidades e inventario. Mientras la demanda individual de clientes se mantiene baja, la asociación con el café proporciona ingresos base estables. Un pedido sorpresa para una boda llega a través de la reputación de boca en boca, demostrando que el trabajo de calidad del pasado genera dividendos. El equipo termina enero financieramente estable y posicionado para una primavera fuerte.",
    "fl_pillar_es": "Demanda estacional, reservas, construcción de inventario, relaciones comerciales, reputación"
  },
  {
    "season": 4,
    "chapter": 12,
    "slug": "s4-ch12",
    "title": "THE BIG PICTURE",
    "summary": "Six-month business review. They tally everything: $1,247 revenue, $389 costs, $858 profit, $214.50 per kid. Each friend reflects on what they gained beyond money — skills, confidence, relationships, purpose. They choose to keep the business running sustainably rather than scaling aggressively or shutting down. The map glows, showing golden threads connecting every customer, the café, the fort, Mr. Mason's workshop, Frances's garden — a living network of relationships. Dim spots remain in unexplored parts of the neighborhood, hinting at future growth.",
    "fl_pillar": "Profit & loss statement (full business review); Revenue by product category and time period; Business sustainability vs. growth; Retained earnings and reinvestment decisions; Return on investment (money and time); Total shareholder value (what each kid gained); Business lifecycle decisions (continue, scale, or close)",
    "thumbnails": {
      "t1": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch12/t1/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch12/t1/es.jpeg"
      },
      "t2": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch12/t2/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch12/t2/es.jpeg"
      },
      "t3": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch12/t3/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch12/t3/es.jpeg"
      },
      "t4": {
        "en": "https://cdn.startupsmartup.com/pe-thumb/s4/ch12/t4/en.jpeg",
        "es": "https://cdn.startupsmartup.com/pe-thumb/s4/ch12/t4/es.jpeg"
      }
    },
    "vocab": [
      {
        "word": "profit",
        "def_en": "the money you keep after you pay for everything you used",
        "def_es": "El dinero que queda después de restar todos los gastos de lo que se vendió",
        "ex_en": "Benny found the profit was 858 dollars.",
        "ex_es": "Benny vio que la ganancia era de 858 dólares.",
        "word_es": "ganancia"
      },
      {
        "word": "net_profit",
        "def_en": "the money left after subtracting every single cost from your total sales; the true measure of what the business earned",
        "def_es": "El beneficio real que queda después de restar todos los costos de los ingresos totales",
        "ex_en": "Benny said the net profit was 858 dollars, what remained after subtracting 389 dollars in costs from 1,247 dollars in revenue.",
        "ex_es": "Benny dijo que la ganancia neta fue de 858 dólares, lo que quedó al restar 389 dólares de gastos a 1,247 dólares de ingresos.",
        "word_es": "ganancia neta"
      },
      {
        "word": "revenue",
        "def_en": "the total money earned from all sales before subtracting costs",
        "def_es": "Todo el dinero que entra por las ventas, antes de descontar cualquier gasto",
        "ex_en": "Pottery brought in 748 dollars of the 1,247 dollars in revenue, which was 60 percent.",
        "ex_es": "La cerámica trajo 748 dólares de los 1,247 dólares de ingresos, el 60 por ciento.",
        "word_es": "ingresos"
      },
      {
        "word": "margin",
        "def_en": "how much you keep on each item after paying what it cost to make",
        "def_es": "La diferencia entre lo que se cobra y lo que cuesta hacer el trabajo — el espacio para ganar dinero",
        "ex_en": "Riley's artist's choice line keeps a bigger margin because people pay more for what she makes.",
        "ex_es": "La línea especial de Riley deja un mejor margen porque la gente paga más por lo que ella hace.",
        "word_es": "margen"
      },
      {
        "word": "reputation",
        "def_en": "the impression customers and the community hold about your business, built through consistent quality and honest dealings",
        "def_es": "La opinión colectiva que otros tienen sobre la calidad y confiabilidad de un negocio",
        "ex_en": "The map kept growing through good reputation and trust, with new threads reaching wedding venues and homes on every street.",
        "ex_es": "El mapa seguía creciendo gracias a la buena reputación y la confianza, con hilos hasta lugares de bodas y casas de cada calle.",
        "word_es": "reputación"
      },
      {
        "word": "inventory",
        "def_en": "things you make ahead of time so they are ready to sell",
        "def_es": "Productos que se preparan con anticipación para tenerlos listos cuando alguien los pida",
        "ex_en": "The plan for spring was to build inventory.",
        "ex_es": "El plan para la primavera era preparar inventario.",
        "word_es": "inventario"
      },
      {
        "word": "scaling",
        "def_en": "growing a business quickly by hiring employees, renting space, and expanding product lines",
        "def_es": "El proceso de hacer crecer un negocio rápidamente, agregando empleados, espacio y productos",
        "ex_en": "Layla explained that scaling meant hiring employees and renting workspace, so the friends would become managers dealing with complexity instead of makers.",
        "ex_es": "Layla explicó que escalar significaba contratar empleados y rentar un lugar, y los amigos pasarían de creadores a jefes con más complicaciones.",
        "word_es": "escalar"
      },
      {
        "word": "partnership",
        "def_en": "the formal closing of a business, where the partners divide up whatever is left",
        "def_es": "Personas que comparten la propiedad, las responsabilidades y las ganancias de un negocio",
        "ex_en": "Option A meant dissolution, where the partners divide the profits and go back to being friends.",
        "ex_es": "La opción A era cerrar el negocio, y los socios se repartían las ganancias y volvían a ser solo amigos.",
        "word_es": "sociedad"
      },
      {
        "word": "pivot",
        "def_en": "to stop making or selling a product for good",
        "def_es": "dejar de hacer o vender un producto para siempre",
        "ex_en": "Dropping the journals was a pivot, because the data showed they were not viable.",
        "ex_es": "Dejar los diarios fue un cambio de rumbo, porque los datos mostraron que no servían como negocio.",
        "word_es": "cambio de rumbo"
      },
      {
        "word": "sustainability",
        "def_en": "ability to keep doing something long-term without burning out",
        "def_es": "Una forma de operar que se puede mantener a largo plazo sin agotar recursos ni personas",
        "ex_en": "Ellis said two hours a week was sustainable alongside school.",
        "ex_es": "Ellis dijo que dos horas por semana era sostenible junto con la escuela.",
        "word_es": "sostenible"
      },
      {
        "word": "receipt",
        "def_en": "a little paper that shows how much you paid for something",
        "def_es": "un papelito que muestra cuánto pagaste por algo",
        "ex_en": "Ellis had all the receipts for clay, glaze and tools.",
        "ex_es": "Ellis tenía todos los recibos de arcilla, esmalte y herramientas.",
        "word_es": "recibo"
      }
    ],
    "title_es": "EL PANORAMA GENERAL",
    "summary_es": "Seis meses después de independizarse, el equipo se reúne para realizar una revisión exhaustiva de su negocio. Suman los ingresos totales, costos y ganancias, luego analizan qué productos tuvieron el mejor rendimiento y cuánto valió su tiempo. Cada miembro reflexiona sobre el crecimiento personal más allá de los números financieros. El equipo evalúa tres opciones para el futuro — cerrar, escalar agresivamente o continuar de forma sostenible — y elige por unanimidad mantener el negocio en su tamaño actual manejable. Crean un plan de un año organizado por trimestre y cierran articulando lo que el negocio significa para cada uno personalmente.",
    "fl_pillar_es": "Ingresos, ganancias, márgenes, sostenibilidad, escalamiento"
  }
];

export const ES_GAPS = [
  "takeaways: pe_chapters.learning_objectives empty for all 48 -> no source (section omitted)",
  "ChaptersGrid CSV: not present on disk",
  "title_es/summary_es/fl_pillar_es: native on-disk ES (48/48) but reverse-engineered -> human REVIEW recommended",
  "vocab headword: ES from pe_concept_lexemes primary term; concepts with multiple ES lexemes are review-flagged (e.g. supply_and_demand)",
];
export function thumbFor(ch: PeChapter, tier: number, lang: Lang): string | undefined {
  return ch.thumbnails["t" + tier]?.[lang];
}
